/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="../../components/baseclasses/guid.ts" />
/// <reference path="../../components/models/meevo.model.custom.ts" />
/// <reference path="inventoryCount.module.ts" />
/// <reference path="../../components/filters/invOnHand.ts" />
/// <reference path="../../components/common/inventory.common.context.ts" />
/// <reference path="../../components/controls/barcodeScanner/barcodeScanner.ts" />
/// <reference path="../../components/modal/modal.enums.ts" />

module Meevo.Plugins.InventoryCount {
    import ProductInventoryTypeEnum = Meevo.Model.ProductInventoryTypeEnum;
    import InventoryCountStateEnum = Meevo.Model.InventoryCountStateEnum;
    import LineItems = Meevo.Model.InventoryCountLineItems;
    import MaintenanceFormState = Meevo.Model.MaintenanceFormState;
    import SecurityAccessEnum = Meevo.Model.SecurityAccessEnum;
    import BarcodeScanModes = Meevo.Components.Controls.BarcodeScanModes;
    import ModalTranslationModes = Meevo.Components.Modal.ModalTranslationModes;
    import ProductUsageAmountTypeEnum = Meevo.Model.ProductUsageAmountTypeEnum;
    const autoSaveDelay : number = 1000;
    const autoSaveKeyPrimary : string = "variantId"
    const autoSaveKeySecondary: string = "productInventoryType";
    enum QuantityViewType {
        Decimal = 0,
        Units = 1
    }
    
    export class InventoryCountContext extends Meevo.Components.Common.InventoryCommonContext {
        backupInventoryCount: Meevo.Model.InventoryCount;
        itemsArrayCtrl: any;
        // selectAllBox: boolean;
        isHideOnHand: boolean;
        isInventoryFloorLocationModuleAvailable: boolean;
        mode: Meevo.Model.MaintenanceFormState; // This controls the UI behavior for the Desktop
        INVENTORY_COUNT_WRITE: string;
        INVENTORY_COUNT_DELETE: string;
        INVENTORY_COUNT_READ: string;
        INVENTORY_COUNT_CREATE: string;
        INVENTORY_COUNT_COMMIT: string;
        INVENTORY_COUNT_LINEITEM_DELETE: string;
        DATA_PRODUCT_TAB_MAIN: string;

        protected securityKeys = Meevo.Components.Common.SecurityKeys;
        protected securityParts = Meevo.Components.Common.SecurityParts;
        protected products: any;
        protected floorLocations: any;
        protected manufacturer: any;
        protected productVariantFilter: string;
        protected includeDiscontinued: boolean;
        protected productVariantInventoryType: ProductInventoryTypeEnum;
        protected productTypes: any;
        public inventoryCount: Meevo.Model.InventoryCount = null;
        protected inventoryCounts: any;
        protected lineItem: LineItems;
        protected floorLocationId: Guid;
        protected lineItemsStatus: any;
        public product: any = {};
        protected controller: any;
        protected confirmationMessage: string;
        public originalActualCount: number;
        protected openInventoryCountStateEnum = InventoryCountStateEnum.Open;
        protected searchCriteria: any;
        protected productSearchCriteria: any;
        protected productLookupCriteria: Model.IInventoryCountProductSearchCriteria;
        protected trueValue: boolean;
        protected $q: ng.IQService;
        protected $timeout: ng.ITimeoutService;
        protected resolvedPromise = true;
        protected isCountStarted = false;
        protected isConflict = false;
        protected customColumns: any;
        protected dateCreatedColumn: any;
        protected recentlyChangedVariableAttribute = "recentlyChanged";
        protected recentlyChangedNumber = 0;
        public isNewCount: boolean = false;
        inAutoSaveProcess: boolean = false;
        inSaveProcess: boolean = false;
        protected countStateExclusionList: InventoryCountStateEnum[];
        public orderItemsByList: any[];
        protected inventoryCountOrder: string = "ManufacturerName";
        private secondaryCountOrder: string = "VariantSku";
        protected inventoryCountSortOption: any = { fieldName: this.inventoryCountOrder, sortDirection: Model.SortDirection.Ascending };
        public isDirty: boolean = false;
        searchScreen: boolean = false;
        baseEndPoint: string;
        allDistributor: boolean;
        allManufacturer: boolean;
        allProductCategory: boolean;
        chkShowNotCountedSince: boolean;
        protected isFilterByComplete: boolean;
        private itemsPerPage: number = 200;
        protected virtualMaximum: number = this.itemsPerPage;
        public distributorMoverModel: any;
        public manufacturerMoverModel: any;
        public productCategoryMoverModel: any;
        private meevoCurrency: any;
        public isAutoSaveEnabled: boolean = true;
        public showAutoSaveSuccessful: boolean = false;
        private autoSaveTimers: any = {};
        private holdLineItems: Record<string, LineItems[]> = {};
        public barcodeScanner: any;
        public searchExpanded: boolean = false;
        public addExpanded: boolean = false;
        public typeaheadCount: number = 0;
        public isPrinting: boolean = false;

        public productSplitFields : any;
        private foundBarcodes: any = [];
        private barcodeScanMode: BarcodeScanModes;

        public successSound : HTMLAudioElement = new Audio("/assets/audio/ding.mp3")
        public failSound : HTMLAudioElement = new Audio("/assets/audio/fail.mp3")
        public highlightId: string;
        public productLookup : any;
        public currentInventoryType : ProductInventoryTypeEnum = null; // applies to next barcode scan when counting retail/shopsupply
        public swiperInstances: any;
        private needsReconciliation: boolean = false;
        private uniqueCodes: any;
        public todayDate : Date = new Date();

        public barcodeScanResults: any = {
            0: [ ], // not found
            1: new Map()// matches
        };
        protected decimalPrecision: number;
        public tenantEnableProductUsageTracking: boolean = false;
        public switchButtons: Meevo.Components.Controls.ISwitchButton[] = [
            { displayName: 'Decimal', key: QuantityViewType.Decimal },
            { displayName: 'Units', key: QuantityViewType.Units },
        ];
        public QuantityViewType = QuantityViewType;
        public viewQuantity: QuantityViewType = QuantityViewType.Decimal;

        get floorLocationKey() : string {
            return this.productSearchCriteria && this.productSearchCriteria.floorLocationId ? this.productSearchCriteria.floorLocationId.toString() : '0';
        }

        constructor(
            protected appSettings: Meevo.Components.Common.IAppSettings,
            protected dataService: Meevo.Components.BaseClasses.IDataService,
            protected busyService: Meevo.Components.Busy.IBusyService,
            protected modalService: Meevo.Components.Modal.IModalService,
            protected roundingService: Meevo.Components.Common.IInventoryRoundingService,
            protected inventoryController: any,
            protected securityChecker: Meevo.Components.Common.SecurityService,
            protected q: ng.IQService,
            protected timeout: ng.ITimeoutService,
            protected meevoDateFilter: any,
            protected $state: any,
            protected $filter: angular.IFilterService,
            protected $rootScope: angular.IRootScopeService,
            private $mdSidenav: any,
            private trackingService: Meevo.Components.Tracking.ITrackingService,
            public $translate: ng.translate.ITranslateService) {

            super(appSettings, $rootScope);

            this.INVENTORY_COUNT_READ = this.securityKeys.INVENTORY_COUNT + this.securityParts.KEY_PART_READ;
            this.INVENTORY_COUNT_WRITE = this.securityKeys.INVENTORY_COUNT + this.securityParts.KEY_PART_WRITE;
            this.INVENTORY_COUNT_DELETE = this.securityKeys.INVENTORY_COUNT + this.securityParts.KEY_PART_DELETE;
            this.INVENTORY_COUNT_CREATE = this.securityKeys.INVENTORY_COUNT + this.securityParts.KEY_PART_CREATE;
            this.INVENTORY_COUNT_COMMIT = this.securityKeys.INVENTORY_COUNT + this.securityParts.KEY_PART_COMMIT;
            this.INVENTORY_COUNT_LINEITEM_DELETE = this.securityKeys.INVENTORY_COUNT_LINEITEM + this.securityParts.KEY_PART_DELETE;
            this.DATA_PRODUCT_TAB_MAIN = this.securityKeys.DATA_PRODUCT_TAB_MAIN + this.securityParts.KEY_PART_READ;
            this.baseEndPoint = `${this.appSettings.API_ROOT}/InventoryCount`;

            this.decimalPrecision = this.appSettings.APP_BUSINFOSETTINGS.generalSettings.inventoryDecimalPrecision || 4;
            this.tenantEnableProductUsageTracking = this.appSettings.APP_BUSINFOSETTINGS.generalSettings.productUsageTracking || false;

            this.controller = inventoryController;
            this.$q = q;
            this.$timeout = timeout;

            this.initializePage();
            console.log('inventory count constructor')

        }

        initializePage(): void {
            this.generateProductSplitFields();
            this.attachPrintListener();
            this.initializeFloorLocations();
            this.searchForInventoryCounts(InventoryCountStateEnum.Open);
            this.resetInventoryCount();
            this.virtualMaximum = 0;
            this.floorLocationId = null;
            this.trueValue = true;
            this.searchScreen = true;
            this.allDistributor = true;
            this.allManufacturer= true;
            this.allProductCategory = true;
            this.chkShowNotCountedSince = false;

            this.productVariantFilter = "";
            this.inventoryCounts = [];
            this.countStateExclusionList=[InventoryCountStateEnum.Reviewing];

            this.lineItemsStatus = [];
            this.lineItemsStatus.push({ "key": null, "value": "LABEL_ALL_ITEM" });
            this.lineItemsStatus.push({ "key": true, "value": "LABEL_COUNTED_ITEM" });
            this.lineItemsStatus.push({ "key": false, "value": "LABEL_NOT_COUNTED_ITEM" });

            this.createOrderByList();            

            this.searchCriteria = {
                "state": InventoryCountStateEnum.Open,
                "productObjectState": Meevo.Model.ObjectStateEnum.Active,
                "variantObjectState": Meevo.Model.ObjectStateEnum.Active,
                "isInventoryTrackable": true,
                "iscounted": null
            };

            this.productSearchCriteria = {
                "productObjectState": Meevo.Model.ObjectStateEnum.Active,
                "variantObjectState": [Meevo.Model.ObjectStateEnum.Active],
                "productInventoryType": ProductInventoryTypeEnum.Retail,
                "isInventoryTrackable": true,
                "floorLocationId": null,
                "id": this.inventoryCount.id,
                "inventoryCountOnly": false,
                "iscounted": null,
                "filter": null,
                "manufacturerIds": [],
                "distributorIds": [],
                "productCatIds": [],
            };

            this.generateProductLookupCriteria();

            this.dateCreatedColumn = { header: "Date Created", fieldName: 'DateCreated', sortDirection: null, width: 20 };

            this.customColumns = [
                { header: "Display Name", fieldName: 'DisplayName', sortDirection: null, width: 45 },
                { header: "Owned By", fieldName: 'OwnedByLocationName', sortDirection: null, width: 30 },
                { header: "Products", fieldName: 'Products', sortDirection: null, width: 25 }
            ];

            this.securityChecker.checkSecurityKey(this.securityKeys.INVENTORY_COUNT_FIELD_ONHAND + Meevo.Components.Common.SecurityParts.KEY_PART_READ)
                .then((securityCode: SecurityAccessEnum) => {
                    this.isHideOnHand = securityCode !== SecurityAccessEnum.Grant;
                });
            this.securityChecker.checkSecurityKey(this.securityKeys.INVENTORY_FLOORLOCATION + Meevo.Components.Common.SecurityParts.KEY_PART_READ)
                .then((securityCode: SecurityAccessEnum) => {
                    this.isInventoryFloorLocationModuleAvailable = securityCode === SecurityAccessEnum.Grant;
                });

            this.meevoCurrency = this.$filter("meevoCurrency") as any;
            this.currentInventoryType = null;
        }

        generateProductLookupCriteria(): any {
            this.productLookupCriteria = {
                productObjectState: Meevo.Model.ObjectStateEnum.Active,
                variantObjectState: [Meevo.Model.ObjectStateEnum.Active, Meevo.Model.ObjectStateEnum.Inactive],
                isInventoryTrackable: true,
                productInventoryType: this.productSearchCriteria.productInventoryType,
                floorLocationId: this.productSearchCriteria.floorLocationId,
                id: this.inventoryCount.id,
                distributorIds: this.distributorMoverModel.isAllSelected ? [] : this.distributorMoverModel.collection,
                manufacturerIds: this.manufacturerMoverModel.isAllSelected ? [] : this.manufacturerMoverModel.collection,
                productCatIds: this.productCategoryMoverModel.isAllSelected? [] : this.productCategoryMoverModel.collection,
                inventoryCountOnly: false
            };
        }

        fixScrolling() : void {
            var timer = setInterval(() => {
                var scroller = document.querySelector('.inventory-count-virtual-repeater .md-virtual-repeat-scroller');
                if (scroller) {
                    scroller.addEventListener('scroll', (e: any) => {
                        this.controller.$scope.$apply();                        
                    });
                    clearInterval(timer);                    
                } else {
                    console.log('virtual repeater not ready')
                }

                var scroller2 = document.querySelector('.inventory-table-container.meevo-scrollbar');
                if (scroller2) {
                    scroller2.addEventListener('scroll', this.scrollHeader);
                    clearInterval(timer);
                } else {
                    console.log('virtual repeater not ready')
                }
            }, 300);
            
        }

        createOrderByList() : void {
            this.orderItemsByList = [];
            this.orderItemsByList.push({ "key": "VariantBarCode", "value": "LABEL_BARCODE" });
            this.orderItemsByList.push({ "key": "DisplayName", "value": "LABEL_DISPLAY_NAME" });
            this.orderItemsByList.push({ "key": "ManufacturerName", "value": "LABEL_MANUFACTURER" });
            if (this.isMiscSupplyCount()) {
                this.orderItemsByList.push({ "key": "SupplyCategory", "value": "LABEL_SUPPLY_CATEGORY" });
            } else {
                this.orderItemsByList.push({ "key": "ProductCategory,ProductSubCategory", "value": "LABEL_INPUT_PRODUCT_CATEGORY" });
            }
            this.orderItemsByList.push({ "key": "VariantSku", "value": "LABEL_SKU_CODE" });
        }

        inventoryTypeChange() : void {
            this.createOrderByList();
            this.generateProductLookupCriteria();
            if (!this.isMiscSupplyCount() && this.inventoryCountSortOption.fieldName == 'SupplyCategory') {
                this.inventoryCountSortOption.fieldName = "ProductCategory";
            } else if (this.isMiscSupplyCount() && this.inventoryCountSortOption.fieldName == 'ProductCategory') {
                this.inventoryCountSortOption.fieldName = "SupplyCategory";
            }
            if (this.inventoryCount.lineItems && this.inventoryCount.lineItems.length > 0) {
                this.search();
            }            
        }

        generateProductSplitFields() : void {
            this.productSplitFields = 
            [
                { 
                    'label': 'LABEL_SKU_CODE',
                    'key': 'sku',
                    'className': 'line-item-link',
                    'sortOrder': ['VariantBarCode', 'DisplayName'].some(x => x == this.inventoryCountOrder) ? 2 : 1
                },
                { 
                    'label': 'LABEL_DISPLAY_NAME',
                    'key': 'displayName',
                    'className': 'line-item-link',
                    'sortOrder': this.inventoryCountOrder == 'DisplayName' ? 1 : this.inventoryCountOrder == 'VariantBarCode' ? 3 : 2
                },
                { 
                    'label': 'LABEL_BARCODE',
                    'key': 'barCode',
                    'className': 'line-item-link',
                    'sortOrder': this.inventoryCountOrder == 'DisplayName' ? 3 : this.inventoryCountOrder == 'VariantBarCode' ? 1 : 3
                }
            ]
        }

        getSplitFieldItem(ndx) : any {
            return this.productSplitFields.find(x => x.sortOrder == ndx) || {};
        }

        getSplitFieldHeader(ndx) : string {
            let item = this.getSplitFieldItem(ndx);
            return item ? this.$translate.instant(item.label) : '';
        }

        getSplitFieldValue(ndx, product) : string {
            let item = this.getSplitFieldItem(ndx);
            return this.getProductSplitFieldValue(product, item.key);
        }

        getSplitFieldId(ndx, product) : string {
            return `${product['entityVersion']}${ndx}`;
        }

        getSplitFieldClass(ndx) : string {
            return this.getSplitFieldItem(ndx).className;
        }
        

        showDataToolTip(item) : boolean {
            if (!item) return false;
            var el = $(`#${item}`)[0];
            if (!el) return false;
            return el.scrollHeight > el.clientHeight + 2;
        }
        
        getProductSplitFieldValue(product, key) : string {
            return key == 'displayName'
                ? this.getLineItemDisplayName(product)
                : product[key] ||  ' ';
        }
        
        getProductTypeaheadHeight() {
            return  { 'min-height': `${($("#mobile-count #product-lookup-input .meevo-typeahead-listContainer").height() || 0) + 60}px` };
        }

        removeAllChildNodes(parent) {
            while (parent.firstChild) {
                parent.removeChild(parent.firstChild);
            }
        }

        getLineItemDisplayName(item) : string {
            return item.productName ? (item.displayName ? `${item.productName} - ${item.displayName}` : item.productName) : item.displayName;
        }
        
        public scannerOpened : string = '';
        openBarcodeScanner(val: string) : void {
            if (!val) return;

            this.scannerOpened = val;
            if (this.scannerOpened !== 'mobile') {
                this.openBarcodeScannerModal();
            }
            this.mode = MaintenanceFormState.Editing;
        }

        openBarcodeScannerModal() : void {
            let options : Meevo.Plugins.Product.IBarcodeScannerOptions = {
                productInventoryTypeEnum: this.currentInventoryType,
                savedInventoryTypeEnum: this.inventoryCount ? this.inventoryCount.productInventoryType : null
            };

            let callbacks : Meevo.Plugins.Product.IBarCodeScannerCallbacks = {
                onScan: this.barcodeSearch.bind(this),
                onDestroy: this.barcodeScannerDestroyed.bind(this),
                onInventoryTypeChange: this.currentInventoryTypeChange.bind(this),
                onBarcodeScanModeChange: this.barcodeScanModeChange.bind(this)
            };

            let modalOptions: Meevo.Components.Modal.IModalOptions = {
                templateUrl: "app/components/controls/barcodeScanner/barcodeScannerModal.template.html",
                controller: "meevo.components.controls.BarcodeScannerModalController",
                controllerAs: "vm",
                parent: "inventory-count",
                bindToController: true,
                escapeToClose: true,
                hasBackdrop: false,
                fullscreen: true,
                locals: {
                    options: options,
                    callbacks: callbacks
                }
            }
            this.modalService.showCustom(modalOptions);
        }

        barcodeScannerDestroyed(isModal) : void {
            console.log('barcodeScannerDestroyed', this)
            if (isModal) {
                this.closeCustomModal();
            } else {
                this.closeBarcodeScanner();
            }
        }

        currentInventoryTypeChange(data: ProductInventoryTypeEnum) : void {
            console.log('currentInventoryTypeChange', data)
            var vm = this;
            setTimeout(() => {
                vm.currentInventoryType = data;    
            });            
        }

        barcodeScanModeChange(scanMode: BarcodeScanModes) : void {
            console.log('barcodeScanModeChange', scanMode)
            this.barcodeScanMode = scanMode;
        }

        doBarcodeScannerOpen() : void {
            if (this.scannerOpened !== 'mobile') {
                this.openBarcodeScannerModal();
            }
        }

        openProductInventoryTypeModal(productVariant, labelText, noteText, listOfTypes) : ng.IPromise<any> {
            let modalOptions : Meevo.Plugins.Product.ProductInventoryTypeModalOptions = {
                product: productVariant,
                labelText: labelText,
                noteText: noteText,
                listOfTypes: listOfTypes
            };

            let options: Meevo.Components.Modal.IModalOptions = {
                templateUrl: "app/plugins/inventoryCount/dialogs/productInventoryTypeModal.template.html",
                controller: "meevo.plugins.inventoryCount.ProductInventoryTypeModalController",
                controllerAs: "vm",
                parent: "inventory-count",
                bindToController: true,
                escapeToClose: true,
                hasBackdrop: false,
                fullscreen: true,
                locals: {
                    options: modalOptions
                }
            }
            return this.modalService.showCustom(options);
        }

        openBarcodeImportReconcilerModal(productVariants: any) : ng.IPromise<any> {
            let modalOptions : Meevo.Plugins.Product.BarcodeImportReconcilerModalOptions = {
                variants: productVariants,
                uniqueCodes: this.uniqueCodes
            };

            let options: Meevo.Components.Modal.IModalOptions = {
                templateUrl: "app/plugins/inventoryCount/dialogs/barcodeImportReconciler.template.html",
                controller: "meevo.plugins.inventoryCount.BarcodeImportReconcilerModalController",
                controllerAs: "vm",
                parent: "inventory-count",
                bindToController: true,
                escapeToClose: true,
                hasBackdrop: false,
                fullscreen: true,
                locals: {
                    options: modalOptions
                }
            }
            return this.modalService.showCustom(options);
        }

        lineItemSwipe(swiper, item) : void {
            console.log('lineItemSwipe', swiper, item)
            var variantId = swiper.container[0].dataset.variantid;
            var productInventoryType = swiper.container[0].dataset.productinventorytype;
            var ndx =  this.inventoryCount.lineItems.findIndex(x => x.variantId == variantId && x.productInventoryType == productInventoryType);
            if (ndx > -1) {
                this.removeLineItem(item);
            }
        }

        
        
        barcodeScanned = (codes) : void => {
            
            setTimeout(() => {
                if (!codes || codes.length < 1) return;
                this.controller.viewSwitch('count');
    
                this.foundBarcodes = codes.filter(x => {
                    return !this.barcodeScanResults[0].some(y => y == x);
                });
    
                if (this.foundBarcodes.length == 0) {
                    this.createBarcodeFailureToast(codes.join(','));
                } else {
                    this.runBarcodeLookup(this.foundBarcodes);
                }
            });
        }

        processSuccessfulBarcodeScan(product) : void {
            this.successSound.play();
            this.recordBarcodeScan(product);
            this.productVariantFilter = "";
        }

        processUnsuccessfulBarcodeScan(codes): void {
            this.createBarcodeFailureToast(codes.join(", "));
            this.recordBarcodeScanMismatch(codes);
        }

        runBarcodeLookup(codes) : void {
            this.barcodeSearch(codes, true).then((res : any) => {
                if (res) {
                    this.processSuccessfulBarcodeScan(Symbol.iterator in Object(res) ? res[0] : res)
                } else if (res === false) {
                    this.processUnsuccessfulBarcodeScan(codes);
                }
                console.log('barcode searched', res);
            }).catch((err) => {
                this.processUnsuccessfulBarcodeScan(codes);
            })
        }

        recordBarcodeScan(product) : void {
            this.barcodeScanResults[1].set(product.barCode, product);
        }

        recordBarcodeScanMismatch(codes) : void {
            for (let i = 0; i < codes.length; i++) {
                this.barcodeScanResults[0].push(codes[i]);
            }
        }

        highlightAddedItem(item) {
            this.$timeout(() => {
                this.ScrollToProduct(item.variantId, item.productInventoryType);
                this.productLookup = null;
            }, 500);
        }

        isMobileUi() : boolean {
            return Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0) < 960;
        }

        ScrollToProduct(id, productInventoryType) : void {
            
            let thisParent, heightOfItem : number;
            if (this.isMobileUi()) {
                thisParent = document.getElementById("mobile-count");    
                heightOfItem = 100;
            } else {
                thisParent = document.getElementById("desktop_count");
                heightOfItem = 56;
            }

            // find the index of the very first matching variant
            let ndx = _.findIndex(this.inventoryCount.lineItems, (item) => { return item.variantId == id && item.productInventoryType == productInventoryType });
            if (thisParent != null && ndx >= 0) {
                // scroll to top of first item matched
                let el = thisParent.getElementsByClassName("md-virtual-repeat-scroller")[0];
                let newScrollTop: number = ndx <= 0 ? 0 : (ndx * heightOfItem);
                newScrollTop = newScrollTop > (el.scrollHeight - el.clientHeight) ? (el.scrollHeight - el.clientHeight) : newScrollTop;
                el.scroll({left: 0, top: newScrollTop, behavior: 'smooth'});

                let highlightInterval = setInterval(() => {
                    var item = $(el).find('#virtual_productId_' + this.getConcatenatedString(id, productInventoryType))[0];
                    if (item) {
                        item.classList.add('item-highlight');
                        setTimeout(() => {
                            item.classList.remove('item-highlight');
                        }, 2000);
                        clearInterval(highlightInterval);
                    }    
                }, 100);

            }
        }

        getConcatenatedString(id, type): string {
            return id + '_' + type;
        }

        createBarcodeFailureToast(code : string) : void {
            var toast = this.controller.$mdToast.simple();
            toast.textContent(`Barcode (${code}) not found.`);
            toast.position("bottom right");
            toast.parent(angular.element("div#barcode-scanner"));
            toast.hideDelay(5000);
            toast.action("X"); // Will close the toast when clicked.
            this.controller.$mdToast.show(toast);
            this.failSound.play();
        }

        openProductDefinition(item: any) {
            item.productId = item.product_TId;
            super.openProductDefinition(item);
        }

        isSecurityDenyOrGrant(key): boolean {
            return this.securityChecker.hasSecurityDenyOrGrant(key);
        }

        replaceBarSymbol(attribute): string{
            if (attribute == null || attribute == undefined || attribute == '')
                return '';
            else
                return " - "+attribute.split(/[|]/g).join(' ');
        }

        showInformation(prod: any) {
            let modalOptions : Meevo.Plugins.Product.ProductInfoModalOptions = {
                parentType: Meevo.Plugins.Product.ProductInfoModalParent.InventoryCount,
                productId: prod.product_TId,
                variantId: prod.variantId,
                productInventoryTypeEnum: prod.productInventoryType,
                isInventoryFloorLocationModuleAvailable: this.isInventoryFloorLocationModuleAvailable
            }

            let options: Meevo.Components.Modal.IModalOptions = {
                templateUrl: "app/plugins/product/modals/productInformation.template.html",
                controller: "meevo.plugins.product.ProductInformationController",
                controllerAs: "vm",
                bindToController: true,
                locals: {
                    options: modalOptions
                }
            }
            this.modalService.showCustom(options);
        }

        showItemConflictInfo(item) {
            return this.showVariantTransaction(item.variantId, item.productInventoryType, item.startOnHandDateTime, item.sku, item.productName, item.displayName, item.barCode, item.onHand, item.decimalPrecision);
        }

        //show conflict information
        showVariantTransaction(variantId: Guid, productType: any, startOnhandDateTime: any, sku: string, productName: string, variantName: string, barCode:string, newOnHand: number, decimalPrecision: number) {
            var variantOnhandChange = {
                "variantId": variantId,
                "productInventoryType": productType,
                "startOnHandDateTime": startOnhandDateTime
            };
            var displayName = productName + this.replaceBarSymbol(variantName);
            this.dataService.customMethodData(`${this.baseEndPoint}/VariantOnHand/List`, "POST", variantOnhandChange).then((d) => {
                let variants = d.data;
                let options: Meevo.Components.Modal.IModalOptions = {
                    templateUrl: "app/plugins/inventoryCount/variantOnHandChange.modal.template.html",
                    controller: "meevo.plugins.inventoryCount.InventoryCountController",
                    controllerAs: "inventoryCountController",
                    bindToController: true,
                    locals: {
                        variants: variants,
                        displayName: displayName,
                        newOnHand: newOnHand,
                        decimalPrecision: decimalPrecision
                    }
                };
                this.modalService.showCustom(options);
            });
        }

        closeCustomModal(): void {
            this.modalService.hide();
            this.closeBarcodeScanner();
        }

        displaysearch() {
            if ((this.inventoryCount.id && this.inventoryCount.state == 1686) || (this.isCountStarted && this.isStateOpen())) {
                return true;
            } else {
                return false;
            }
        }

        takeBackup(): void {
            this.backupInventoryCount = angular.copy(this.inventoryCount);
        }

        resetInventoryCountChanges(): void {
            this.inventoryCount = angular.copy(this.backupInventoryCount);
        }
        clearLineItems() {
            this.holdLineItems[this.floorLocationId ? this.floorLocationId.toString() : '0'] = angular.copy(this.inventoryCount.lineItems);
            this.inventoryCount.lineItems = [];
        }

        filteredLineItems() : LineItems[] {
            if (!this.inventoryCount || !this.inventoryCount.lineItems) {
                return [];
            }
            if (!this.productVariantFilter) {
                return this.inventoryCount.lineItems;
            }
            return this.inventoryCount.lineItems.filter(x => `${x.productName}|${x.displayName}|${x.barCode}|${x.sku}`.toLowerCase().indexOf(this.productVariantFilter.toLowerCase()) > -1);
        }

        printableLineItems() : LineItems[] {
            // deleted items are hidden from non-print view with css for a collapsable height animation and fade out transition after mobile swipe removal
            return this.filteredLineItems().filter(x => !x.isDeleted); 
        }

        attachPrintListener() : void {
            // print template behind an ngif so we don't have to add another ng-repeat to DOM unnecessarily
            window.addEventListener('beforeprint', (event) => {
                setTimeout(() => {
                    this.isPrinting = true;
                    this.controller.$scope.$apply();
                }, 1);
            });

            window.addEventListener('afterprint', (event) => {
                setTimeout(() => {
                    this.isPrinting = false;
                    this.controller.$scope.$apply();
                }, 1);
            });
        }

        createNewCount(): void {
            this.mode = MaintenanceFormState.Adding;
            this.showSidebar();
            this.searchScreen = false;
            this.isCountStarted = true;
            this.chkShowNotCountedSince = false;
            this.floorLocationId = null;
            this.inventoryCount.lineItems = [];
            this.inventoryCount.state = InventoryCountStateEnum.Open;
            this.resetSearchCriteria();
            this.controller.viewSwitch('newCount');
            this.fixScrolling();
        }

        resetSearchCriteria() {
            this.productVariantFilter = "";
            this.includeDiscontinued = false;
            if (this.productSearchCriteria) {
                this.productSearchCriteria.floorLocationId = null;
                this.productSearchCriteria.showProdNotCntSince = null;
                this.productSearchCriteria.id = null;
            }

        }
        
        edit(): void {
            this.mode = MaintenanceFormState.Editing;
            this.isAutoSaveEnabled = true;
            this.showSidebar();
            this.attachMobileProductLookupHandler();
        }

        add(): void {
            this.mode = MaintenanceFormState.Adding;
            this.isAutoSaveEnabled = true;
        }

        cancel(): void {
            this.searchScreen = this.isAdding() ? true : false;
            
            if (this.isEditing()) {
                this.resetInventoryCountChanges();
                this.hideSidebar()
            }
            this.resetSearchCriteria();
            this.closeBarcodeScanner();
            this.makeReadonly();
            this.isDirty = false;
        }

        isAdding(): boolean {
            return this.mode == MaintenanceFormState.Adding;
        }

        isEditing(): boolean {
            return this.mode == MaintenanceFormState.Editing;
        }

        isReadonly(): boolean {
            return this.mode == MaintenanceFormState.Readonly;
        }
        
        back(): void {
            this.resetSearchCriteria();
            this.searchScreen = true;
            this.controller.viewSwitch('editCount');
        }

        isStateOpen(): boolean {
            if (!this.inventoryCount) return true;
            return this.inventoryCount.state == InventoryCountStateEnum.Open;
        }
        
        setupProductSearchCriteria(): void {
            this.productVariantFilter = "";
            this.productLookup = null;
            this.productSearchCriteria.productObjectState = Meevo.Model.ObjectStateEnum.Active;
            this.productSearchCriteria.productInventoryType = this.inventoryCount.productInventoryType;
            this.productSearchCriteria.variantObjectState = this.includeDiscontinued ?
                [Meevo.Model.ObjectStateEnum.Active, Meevo.Model.ObjectStateEnum.Inactive] : [Meevo.Model.ObjectStateEnum.Active];
            this.productSearchCriteria.isInventoryTrackable = true ;                
            this.productSearchCriteria.floorLocationId = this.floorLocationId;
            this.productSearchCriteria.filter = Model.Guard.isSomething(`%${this.productVariantFilter}%`) ? "%" + this.productVariantFilter + "%" : null;
            this.productSearchCriteria.id = this.inventoryCount.id;
            this.productSearchCriteria.inventoryCountOnly = this.inventoryCount.inventoryCountOnly;
            this.productSearchCriteria.iscounted = this.inventoryCount.iscounted;
            this.productSearchCriteria.manufacturerIds = this.inventoryCount.manufacturerIds;
            this.productSearchCriteria.distributorIds = this.inventoryCount.distributorIds;
            this.productSearchCriteria.productCatIds = this.inventoryCount.productCatIds;
            this.productSearchCriteria.showProdNotCntSince = this.inventoryCount.showProdNotCntSince;
            this.productSearchCriteria.chkShowNotCountedSince = this.inventoryCount.showProdNotCntSince ? true : false;             

            this.manufacturerMoverModel.collection = angular.copy(this.inventoryCount.manufacturerIds);
            this.manufacturerMoverModel.isAllSelected = (this.manufacturerMoverModel.collection.length == 0);
            this.distributorMoverModel.collection = angular.copy(this.inventoryCount.distributorIds);
            this.distributorMoverModel.isAllSelected = (this.distributorMoverModel.collection.length == 0);
            this.productCategoryMoverModel.collection = angular.copy(this.inventoryCount.productCatIds);
            this.productCategoryMoverModel.isAllSelected = (this.productCategoryMoverModel.collection.length == 0);

            this.createOrderByList();
        }

        initializeFloorLocations(): void {
            this.dataService.customMethodData("api/FloorLocation/List", "GET", null).then((d) => {
                this.floorLocations = [];
                this.floorLocations.push({ "key": null, "value": "All Locations" });
                for (var i = 0; i < d.data.length; i++) {
                    var location = { "key": d.data[i].id, "value": d.data[i].displayName };
                    this.floorLocations.push(location);
                }
            });
        }
        addIncludeDiscontinuedSearchCriteria() {

            this.productSearchCriteria.variantObjectState = this.includeDiscontinued ?
                [Meevo.Model.ObjectStateEnum.Active, Meevo.Model.ObjectStateEnum.Inactive] : [Meevo.Model.ObjectStateEnum.Active];           
        }

        addWildCardToFilter(): void{
             this.productSearchCriteria.filter = Model.Guard.isSomething(`%${this.productVariantFilter}%`) ? "%" + this.productVariantFilter + "%" : null;
        }

        /**
         * Search for product by barcode
         * */
        barcodeSearch(codes, silent: boolean = false): ng.IPromise<any> {
            console.log('barcodeScanMode', this.barcodeScanMode, codes);
            if (!codes || codes.length < 1) return;
            if (!silent) {
                this.busyService.start();
            }
            let foundCodes = angular.copy(codes);
            this.uniqueCodes = foundCodes.filter((item, i, ar) => item.trim() && ar.indexOf(item) === i);
            var unresolvedCode = false;
            for (let index = 0; index < this.uniqueCodes.length; index++) {
                const code = this.uniqueCodes[index];
                if (this.barcodeScanResults[1].has(code)) {
                    var item = this.barcodeScanResults[1].get(code);
                    if (item.productInventoryType == this.currentInventoryType || item.productInventoryType == ProductInventoryTypeEnum.Other || !this.currentInventoryType) {
                        item.importCount = foundCodes.filter(code => code === item.barCode).length;
                        this.handleBarcodeMatch(item);
                    }
                }
                else {
                    unresolvedCode = true;
                }
            }
            if (!unresolvedCode) return this.$q.resolve();

            var request = {
                barCodes: this.uniqueCodes,
                returnInventoryTrackableOnly: true
            }
            return this.dataService.customMethodData(`${this.baseEndPoint}/BarcodeLookup/List`, "POST", request)
                .then((res: Array<LineItems> | any) => {
                    if (!silent) {
                        this.busyService.stop();
                    }

                    if (this.barcodeScanMode == BarcodeScanModes.Camera || this.barcodeScanMode == BarcodeScanModes.File) {
                        
                        let productVariant = res.data[0];
                        if (!productVariant) {
                            this.processUnsuccessfulBarcodeScan(this.uniqueCodes);
                            return this.$q.reject();
                        }

                        productVariant.importCount = foundCodes.filter(code => code === productVariant.barCode).length || 1;

                        console.log('single productVariant', productVariant);
                        
                        // check for exact match
                        if (foundCodes.some(x => x.toUpperCase().trim() == productVariant.barCode.toUpperCase().trim())) {
                            if ((this.inventoryCount.productInventoryType == ProductInventoryTypeEnum.Other && productVariant.productInventoryType !== ProductInventoryTypeEnum.Other) ||
                                (this.inventoryCount.productInventoryType == ProductInventoryTypeEnum.Retail && productVariant.productInventoryType == ProductInventoryTypeEnum.ShopSupply) ||
                                (this.inventoryCount.productInventoryType == ProductInventoryTypeEnum.ShopSupply && productVariant.productInventoryType == ProductInventoryTypeEnum.Retail)) {
                                this.failSound.play();
                                this.modalService.alert('LABEL_INVALID_PRODUCT_INVENTORY_TYPE_SCANNED', Meevo.Components.Modal.ModalTranslationModes.Translate).then((res) => {
                                    this.recordBarcodeScanMismatch([productVariant.barCode]); // invalid for this session
                                    this.doBarcodeScannerOpen();
                                });
                                return null;
                            }

                            if (productVariant.variantId !== this.product.variantId) {
                                this.currentInventoryType = null; // reset if new product scanned
                            }

                            if (!this.inventoryCount.productInventoryType && productVariant.productInventoryType !== ProductInventoryTypeEnum.Other) { // count has no saved type at header level yet
                                var types;
                                if (productVariant.productInventoryType == ProductInventoryTypeEnum.RetailOrShopSupply) {
                                    types = [ProductInventoryTypeEnum.Retail, ProductInventoryTypeEnum.ShopSupply, ProductInventoryTypeEnum.RetailOrShopSupply];    
                                }
                                else {
                                    types = [productVariant.productInventoryType, ProductInventoryTypeEnum.RetailOrShopSupply];    
                                }

                                return this.openProductInventoryTypeModal(null, "LABEL_INVENTORY_COUNT_TYPE_CHOICE", null, types).then((data) => {
                                    if (data) {
                                        this.inventoryCount.productInventoryType = this.productSearchCriteria.productInventoryType = data;
                                        if (data !== ProductInventoryTypeEnum.RetailOrShopSupply) {
                                            this.currentInventoryType = data;
                                            this.inventoryCount.lineItems = this.inventoryCount.lineItems.filter(x => x.productInventoryType == data && !x.isCounted);
                                        }
                                        return this.handleBarcodeMatch(productVariant);
                                    }

                                }).catch(() => {
                                    return null;
                                });
                            }
                            else {
                                return this.handleBarcodeMatch(productVariant);
                            }
   
                        }
                        return res.data;
                    }
                    else if (this.barcodeScanMode == BarcodeScanModes.Device) {
                        var processMatches = () : ng.IPromise<any> => {
                            this.needsReconciliation = (!this.currentInventoryType || 
                                this.currentInventoryType == ProductInventoryTypeEnum.RetailOrShopSupply) &&
                                res.data.some(x => x.productInventoryType == ProductInventoryTypeEnum.RetailOrShopSupply);

                            if (!this.inventoryCount.productInventoryType && (inventoryTypeBreakdown[ProductInventoryTypeEnum.RetailOrShopSupply] || 
                                (inventoryTypeBreakdown[ProductInventoryTypeEnum.Retail] && inventoryTypeBreakdown[ProductInventoryTypeEnum.ShopSupply]))) {
                                    this.setProductSearchCriteria(ProductInventoryTypeEnum.RetailOrShopSupply);
                                }

                            for (const key in res.data) {
                                res.data[key].importCount = foundCodes.filter(code => code === res.data[key].barCode).length;
                                if (!this.needsReconciliation) {
                                    this.handleBarcodeMatch(res.data[key], false);
                                }
                            }
                            
                            if (this.needsReconciliation) {
                                this.setProductSearchCriteria(ProductInventoryTypeEnum.RetailOrShopSupply);
                                return this.openBarcodeImportReconcilerModal(res.data).then((variants) => {
                                    console.log('res from openBarcodeImportReconcilerModal', variants);
                                    this.needsReconciliation = false;
                                    if (!variants) return this.$q.resolve();
                                    for (const item of variants.filter(x => x.isCounted)) {
                                        if (item.productInventoryType == ProductInventoryTypeEnum.RetailOrShopSupply) {
                                            var itemRetail = angular.copy(item);
                                            itemRetail.productInventoryType = ProductInventoryTypeEnum.Retail;
                                            itemRetail.importCount = itemRetail.retailImportCount;
                                            itemRetail.onHand = itemRetail.onHandRetail;
                                            itemRetail.productUsageType = itemRetail.productUsageTypeRetail;
                                            itemRetail.unitOfMeasureQuantity = 1;
                                            if (itemRetail.importCount > 0) {
                                                this.processVariant(itemRetail, false);
                                            }

                                            var itemShopSupply = angular.copy(item);
                                            itemShopSupply.productInventoryType = ProductInventoryTypeEnum.ShopSupply;
                                            itemShopSupply.importCount = itemShopSupply.shopImportCount;
                                            itemShopSupply.onHand = itemShopSupply.onHandShopSupply;
                                            itemShopSupply.productUsageType = itemShopSupply.productUsageTypeShopSupply;
                                            if (itemShopSupply.importCount > 0) {
                                                this.processVariant(itemShopSupply, false);
                                            }
                                        }
                                        else {
                                            if (item.importCount > 0) {
                                                this.processVariant(item, false);
                                            }
                                        }
                                    }
                                    this.saveInventoryCount(true, (this.scannerOpened == 'mobile'));
                                    this.successSound.play();
                                });
                            }
                            else {
                                this.saveInventoryCount(true, (this.scannerOpened == 'mobile'));
                                this.successSound.play();
                            }
                            
                            return this.$q.resolve();
                        }

                        var handleBadVariants = () : ng.IPromise<any> => {
                            return this.modalService.alert(this.$translate.instant('LABEL_INVENTORY_COUNT_INVALID_INVENTORY_TYPE_SCANNED', {
                                'productInventoryType': this.$translate.instant(`ENUM_LABEL_${this.inventoryCount.productInventoryType || ProductInventoryTypeEnum.RetailOrShopSupply}`), 
                                'badVariants': badVariants.displayString})).then(() => {
                                    res.data = res.data.filter(x => !badVariants.ids.some(y => y == `${x.variantId}${x.productInventoryType}`));
                                    return processMatches();
                            });
                        }

                        var handleNotFoundBarcodes = (codes) : ng.IPromise<any> => {
                            this.failSound.play();
                            return this.modalService.alert(this.$translate.instant('LABEL_INVENTORY_COUNT_BARCODE_NOT_FOUND',{
                                'notFoundBarcodes': `<br /><br /> ${codes.join('<br />')}`
                            }), ModalTranslationModes.Translate, false, { okButtonContentKey: 'LABEL_CONTINUE' });
                        }                  

                        //console.log('productVariant in bulk found', res.data);

                        let inventoryTypeBreakdown = this.getInventoryTypeBreakdown(res.data);

                        var badVariants = { displayString:"", ids: [] };
                        var notFoundBarcodes = this.uniqueCodes.filter(x => !res.data.some(y => y.barCode.toLowerCase() === x.toLowerCase()));
                        console.log('notFoundBarcodes', notFoundBarcodes)

                        var removeMiscSupplyVariants = (this.inventoryCount.productInventoryType
                                                            && this.inventoryCount.productInventoryType != ProductInventoryTypeEnum.Other
                                                            && inventoryTypeBreakdown[ProductInventoryTypeEnum.Other])
                                                        || (this.inventoryCount.productInventoryType != ProductInventoryTypeEnum.Other
                                                            && inventoryTypeBreakdown[ProductInventoryTypeEnum.Other] < res.data.length);

                        for (let element of res.data) {
                            if (removeMiscSupplyVariants && element.productInventoryType == ProductInventoryTypeEnum.Other) {
                                    badVariants.displayString += `<br />${this.getLineItemDisplayName(element)}`;
                                    badVariants.ids.push(`${element.variantId}${element.productInventoryType}`);
                            }
                            else if (this.inventoryCount.productInventoryType && 
                                    this.inventoryCount.productInventoryType != element.productInventoryType &&
                                    this.inventoryCount.productInventoryType != ProductInventoryTypeEnum.RetailOrShopSupply) {
                                        if (element.productInventoryType == ProductInventoryTypeEnum.RetailOrShopSupply) {
                                            element.productInventoryType = this.inventoryCount.productInventoryType;
                                        }
                                        else {
                                            badVariants.displayString += `<br />${this.getLineItemDisplayName(element)}`;
                                            badVariants.ids.push(`${element.variantId}${element.productInventoryType}`);
                                        }
                            } 
                        }

                        if (notFoundBarcodes.length > 0) {
                            return handleNotFoundBarcodes(notFoundBarcodes).then(() => {
                                if (badVariants.ids.length > 0) {
                                    return handleBadVariants();
                                } else {
                                    return processMatches();
                                }
                            })
                        }
                        else if (badVariants.ids.length > 0) {
                            return handleBadVariants();
                        }
                           
                        return processMatches();                  

                    }
                    else {
                        return [];
                    }
                })
                .catch(() => {
                    if (!silent) {
                        this.busyService.stop();
                    }
                    return false;
                });
        }
        

        processVariant = (variant, doAutoSave = true) : any => {
            variant = this.incrementCount(variant);
            this.updateProductAndUpdateCount(variant, true);
            this.highlightAddedItem(variant);
            if (doAutoSave) {
                this.handleAutoSave(variant);
                this.successSound.play();
            }
            return variant
        }

        getInventoryTypeBreakdown(data) : any {
            return data.reduce((p, c) => {
                var name = c.productInventoryType
                if (!p.hasOwnProperty(name)) {
                  p[name] = 0;
                }
                p[name]++;
                return p;
              }, {});
        }

        handleBarcodeMatch(productVariant, doAutoSave: boolean = true) : any {
            
            console.log('handleBarcodeMatch', this.barcodeScanMode, productVariant);
            switch (productVariant.productInventoryType) {
                case ProductInventoryTypeEnum.RetailOrShopSupply:
                    if (this.currentInventoryType || this.inventoryCount.productInventoryType == ProductInventoryTypeEnum.Retail || this.inventoryCount.productInventoryType == ProductInventoryTypeEnum.ShopSupply) {
                        productVariant.productInventoryType = this.currentInventoryType || this.inventoryCount.productInventoryType;
                        this.processVariant(productVariant, doAutoSave);
                        return productVariant;
                    } else {
                        var scannerOpened = this.scannerOpened;
                        if (this.scannerOpened == 'desktop') {
                            // about to open another md-dialog
                            this.closeBarcodeScanner();
                        } 

                        if (!this.needsReconciliation) {
                            var types = [ProductInventoryTypeEnum.Retail, ProductInventoryTypeEnum.ShopSupply];
                            return this.openProductInventoryTypeModal(productVariant, "LABEL_INVENTORY_COUNT_TYPE_LINEITEM_CHOICE", "LABEL_INVENTORY_COUNT_TYPE_LINEITEM_CHOICE_NOTE", types).then((data : ProductInventoryTypeEnum) => {
                                if (!data) return;
                                
                                this.currentInventoryType = data;
                                if (this.currentInventoryType !== this.productSearchCriteria.productInventoryType && productVariant.productInventoryType != ProductInventoryTypeEnum.RetailOrShopSupply) {
                                    this.setProductSearchCriteria(this.currentInventoryType);
                                }
                                productVariant.productInventoryType = data;
                                productVariant = this.processVariant(productVariant, doAutoSave);
                                
                                this.doBarcodeScannerOpen();
                                this.scannerOpened = scannerOpened;
                                return productVariant;
                            }).catch(() => {
                                return null;
                            });
                        }
                    }
                    break;
                case ProductInventoryTypeEnum.Other:
                    if (!this.inventoryCount.productInventoryType) {
                        this.inventoryCount.lineItems = this.inventoryCount.lineItems.filter(x => x.productInventoryType == ProductInventoryTypeEnum.Other && !x.isCounted);
                        this.setProductSearchCriteria(ProductInventoryTypeEnum.Other);
                    } else if (this.inventoryCount.productInventoryType != ProductInventoryTypeEnum.Other) {
                        this.failSound.play();
                        this.modalService.alert('LABEL_INVALID_PRODUCT_INVENTORY_TYPE_SCANNED', Meevo.Components.Modal.ModalTranslationModes.Translate).then((res) => {
                            this.doBarcodeScannerOpen();
                        });
                        return null;
                    }
                    break;
                case ProductInventoryTypeEnum.Retail:
                    if (this.currentInventoryType == ProductInventoryTypeEnum.ShopSupply) {
                        this.setProductSearchCriteria(ProductInventoryTypeEnum.RetailOrShopSupply);
                    } else if (this.productSearchCriteria.productInventoryType !== ProductInventoryTypeEnum.RetailOrShopSupply) {
                        this.setProductSearchCriteria(ProductInventoryTypeEnum.Retail);
                    }
                    if (this.barcodeScanMode == BarcodeScanModes.Camera) {
                        this.openBarcodeScanner(this.scannerOpened);
                    }
                    
                    break;
                case ProductInventoryTypeEnum.ShopSupply:
                    if (this.currentInventoryType == ProductInventoryTypeEnum.Retail) {
                        this.setProductSearchCriteria(ProductInventoryTypeEnum.RetailOrShopSupply);
                    } else if (this.productSearchCriteria.productInventoryType !== ProductInventoryTypeEnum.RetailOrShopSupply) {
                        this.setProductSearchCriteria(ProductInventoryTypeEnum.ShopSupply);
                    }
                    if (this.barcodeScanMode == BarcodeScanModes.Camera) {
                        this.openBarcodeScanner(this.scannerOpened);
                    }
                    break;
                default:
                    return null;
                    
            }
            if (this.productSearchCriteria.productInventoryType !== ProductInventoryTypeEnum.RetailOrShopSupply) {
                this.currentInventoryType = productVariant.productInventoryType;
            }
            
            this.processVariant(productVariant, doAutoSave);
            return productVariant;
        }

        setProductSearchCriteria(value) {
            this.productSearchCriteria['productInventoryType'] = value;
            this.generateProductLookupCriteria();
            this.createOrderByList();
        }

        incrementCount(product): any {
            var ndx = this.inventoryCount.lineItems.findIndex(x => x.variantId == product.variantId &&  x.productInventoryType == product.productInventoryType)
            if (ndx > -1) {
                var lineItem = this.inventoryCount.lineItems[ndx];
                lineItem.isCounted = true;
                lineItem.actualCount = this.roundingService.add(lineItem.actualCount, product.importCount);
                lineItem.totalActualCountDisplay = this.getTotalActualCount(lineItem);
                if (lineItem.totalActualCountDisplay > 0) {
                    lineItem.isDeleted = false;
                }

                if (!lineItem.inventoryCountLineItemModalList) {
                    lineItem.inventoryCountLineItemModalList = [];
                }
                if (this.tenantEnableProductUsageTracking
                    && lineItem.enableProductUsageTracking
                    && lineItem.productUsageType == Meevo.Model.ProductUsageAmountTypeEnum.PartialAmount) {
                    // add modal data
                    let newIndex = lineItem.inventoryCountLineItemModalList.length;
                    lineItem.inventoryCountLineItemModalList[newIndex] = {
                        sortOrder: newIndex,
                        productInventoryType: lineItem.productInventoryType,
                        variant_TId: lineItem.variantId || lineItem.id,
                        productUsageType: Meevo.Model.ProductUsageAmountTypeEnum.WholeProduct,
                        quantity: product.importCount,
                        floor_LId: this.inventoryCount.floorLocationId,
                    };
                }
                return lineItem;
            } else {
                product.isCounted = true;
                product.actualCount = product.importCount;
                product.totalActualCountDisplay = this.getTotalActualCount(product);
                if (product.totalActualCountDisplay > 0) {
                    product.isDeleted = false;
                }

                if (!product.inventoryCountLineItemModalList) {
                    product.inventoryCountLineItemModalList = [];
                }
                if (this.tenantEnableProductUsageTracking
                    && product.enableProductUsageTracking
                    && product.productUsageType == Meevo.Model.ProductUsageAmountTypeEnum.PartialAmount) {
                    // add modal data
                    let newIndex = product.inventoryCountLineItemModalList.length;
                    product.inventoryCountLineItemModalList[newIndex] = {
                        sortOrder: newIndex,
                        productInventoryType: product.productInventoryType,
                        variant_TId: product.variantId || product.id,
                        productUsageType: Meevo.Model.ProductUsageAmountTypeEnum.WholeProduct,
                        quantity: product.importCount,
                        floor_LId: this.inventoryCount.floorLocationId,
                    };
                }

                return product;
            }
        }
        
        resetInventoryCount(): void {
            this.holdLineItems = {};
            this.inventoryCount = {
                id: null,
                displayName: "",
                floorLocationId: null,
                dateCreated: null,
                dateUpdated: null,
                entityVersion: 0,
                productInventoryType: null,
                lineItems: null,
                state: null,
                userName: "",
                iscounted: null,
                inventoryCountOnly: false,
                orderItemsBy: "ManufacturerName",
                distributorIds: [],
                manufacturerIds: [],
                productCatIds: []
            };

            this.distributorMoverModel = {
                collection: [],
                isAllSelected: true
            };

            this.manufacturerMoverModel = {
                collection: [],
                isAllSelected: true
            };

            this.productCategoryMoverModel = {
                collection: [],
                isAllSelected: true
            };

            this.barcodeScanResults = { 0: [ ], 1: new Map() };
        }

        setInventoryCountDefaults(): void {
            let today = moment();
            this.inventoryCount.displayName = "Count on " + this.meevoDateFilter(moment().toDate());
            this.setProductSearchCriteria(ProductInventoryTypeEnum.Retail);
            this.productSearchCriteria.iscounted=null
           // this.inventoryCount.iscounted = null;
            this.isNewCount = true;
        }

        getSearchCriteria(pageNum, itemsPerPage) {
            this.productSearchCriteria.manufacturerIds = this.manufacturerMoverModel.isAllSelected ? [] : this.manufacturerMoverModel.collection;
            this.productSearchCriteria.distributorIds = this.distributorMoverModel.isAllSelected ? [] : this.distributorMoverModel.collection;
            this.productSearchCriteria.productCatIds = this.productCategoryMoverModel.isAllSelected ? [] : this.productCategoryMoverModel.collection;
            this.productSearchCriteria.filter = Model.Guard.isSomething(`%${this.productVariantFilter}%`) ? "%" + this.productVariantFilter + "%" : null;

            return {
                pageNumber: pageNum,
                itemsPerPage: itemsPerPage,
                criteria: this.productSearchCriteria,
                sortBy: this.getSearchCriteriaSortBy()
            };
        }

        getSearchCriteriaSortBy() {
            if ((this.inventoryCount.orderItemsBy = this.inventoryCountOrder = this.inventoryCountSortOption.fieldName) == this.secondaryCountOrder) {
                return this.inventoryCountSortOption.fieldName;
            } else {
                return `${this.inventoryCountSortOption.fieldName}, ${this.secondaryCountOrder}`
            }
        }

        searchButtonClicked() {
            this.hideSidebar();
            this.search();
        }

        search() {
            this.inventoryCount.floorLocationId = this.productSearchCriteria.floorLocationId;
            this.controller.viewSwitch('count');
            this.productSearchCriteria.id = this.inventoryCount.id;
            if (this.inSaveProcess || this.inAutoSaveProcess)
                return;
            this.clearLineItems();
            this.inSaveProcess = true;
            this.busyService.start();
            return this.performSearch(0)
                .then(() => {
                    if (this.inventoryCount) {
                        this.inventoryCountOrder = this.inventoryCountSortOption.fieldName = this.inventoryCount.orderItemsBy;
                    }
                }).catch((error) => {

                }).finally(() => {
                    this.busyService.stop();
                    this.inSaveProcess = false;
                    this.generateProductSplitFields();
                    //let trackInfo: Model.TrackingItem = 
                    this.trackingService.saveTrackingInfo(new Model.TrackingItem(Model.NounEnum.InventoryCountPage,
                                                                                 Model.VerbEnum.SearchButtonClicked,
                                                                                 this.productSearchCriteria));
                });
        }

        sumObjectProperties(items, prop) : number {
            return items.reduce((a, b) => {
                return this.roundingService.add(a, b[prop], this.decimalPrecision);
            }, 0);
        };

        getHeldCountForAllFloorLocations(obj: LineItems): { actualCount: number, actualCountUnits?: number } {
            var matchedItems = [];
            var returnCount = { actualCount: 0, actualCountUnits: null };

            Object.keys(this.holdLineItems).forEach(key => {
                var item = this.holdLineItems[key].find(x => x.variantId == obj.variantId && x.productInventoryType == obj.productInventoryType && x.isCounted);
                if (item && item.floorLocationId) {
                    matchedItems.push(item);
                }
            });

            if (matchedItems.length > 0) {
                returnCount.actualCount = this.sumObjectProperties(matchedItems, "actualCount");
                returnCount.actualCountUnits = this.sumObjectProperties(matchedItems, "actualCountUnits");
            }
            else {
                var item = this.holdLineItems['0'].find(x => x.variantId == obj.variantId && x.productInventoryType == obj.productInventoryType && x.isCounted);
                returnCount.actualCount = item ? item.actualCount : obj.actualCount;
                returnCount.actualCountUnits = item ? item.actualCountUnits : obj.actualCountUnits;
            }

            return returnCount;
        }

        performSearch(pageNumber: number = 0): ng.IPromise<any> {
            return this.dataService.customMethodData(`${this.baseEndPoint}/ProductVariant/List`, "POST", this.getSearchCriteria(pageNumber, this.itemsPerPage))
                .then((response) => {
                    if (response && response.data && response.data.length > 0) {
                        this.floorLocationId = this.productSearchCriteria.floorLocationId;
                        if (this.floorLocationKey == "0") {
                            response.data.forEach((obj: LineItems) => {
                                let returnCount = this.getHeldCountForAllFloorLocations(obj);
                                obj.actualCount = returnCount.actualCount;
                                obj.actualCountUnits = returnCount.actualCountUnits;
                                obj.totalActualCountDisplay = this.getTotalActualCount(obj);
                                let item = this.holdLineItems['0'].find(x => x.variantId == obj.variantId && x.productInventoryType == obj.productInventoryType);
                                obj.isCounted = item ? item.isCounted : obj.actualCount > 0;
                                let onHandValue = obj.startOnHand == null ? (obj.onHand || 0) : obj.startOnHand;
                                obj.decimalPrecision = (this.isProductUsageEnabled(obj) || this.hasPartial(onHandValue)) ? this.decimalPrecision : null;
                            });
                        }
                        else if (this.holdLineItems[this.floorLocationKey]) {
                            this.holdLineItems[this.floorLocationKey].forEach((obj: LineItems) => {
                                const index = response.data.findIndex((x: LineItems) => x.variantId == obj.variantId && x.productInventoryType == obj.productInventoryType && obj.isCounted);
                                if (index >= 0) {
                                    response.data[index].actualCount = obj.actualCount;
                                    response.data[index].actualCountUnits = obj.actualCountUnits;
                                    response.data[index].totalActualCountDisplay = this.getTotalActualCount(obj);
                                    response.data[index].isCounted = obj.isCounted;
                                    let onHandValue = obj.startOnHand == null ? (obj.onHand || 0) : obj.startOnHand;
                                    response.data[index].decimalPrecision = (this.isProductUsageEnabled(obj) || this.hasPartial(onHandValue)) ? this.decimalPrecision : null;
                                }
                            });
                        }
                        else {
                            response.data.forEach((obj: LineItems) => {
                                obj.totalActualCountDisplay = this.getTotalActualCount(obj);
                                let onHandValue = obj.startOnHand == null ? (obj.onHand || 0) : obj.startOnHand;
                                obj.decimalPrecision = (this.isProductUsageEnabled(obj) || this.hasPartial(onHandValue)) ? this.decimalPrecision : null;
                            });
                        }
                        this.inventoryCount.lineItems.push(...response.data);
                        if (response.data.length >= this.itemsPerPage) {
                            return this.performSearch(++pageNumber);
                        }
                    }
                    return this.inventoryCount.lineItems;
                });
        }

        selectCount(count: Meevo.Model.InventoryCount): ng.IPromise<any> {
            this.controller.viewSwitch('count');
            return this.dataService.customMethodData(`${this.baseEndPoint}/${count.id}`, "GET", null).then((d) => {
                d.data.lineItems.map(product => {
                    product.imageURL = this.getImageURL(product);
                });
                this.productSearchCriteria.floorLocationId = null;
                this.floorLocationId = null;
                this.isAutoSaveEnabled = true;
                this.inventoryCount = d.data;
                this.holdLineItems = {};
                this.inventoryCountOrder = this.inventoryCountSortOption.fieldName = this.inventoryCount.orderItemsBy;
                var tempCount = 0;
                if (this.inventoryCount != null && this.inventoryCount.lineItems.length > 0) {
                    for (var i = 0; i < this.inventoryCount.lineItems.length; i++) {
                        let li = this.inventoryCount.lineItems[i];
                        if (li.objectState == Meevo.Model.ObjectStateEnum.Inactive)
                            tempCount++;
                        if ((!li.isOverride
                            && li.productVariantsPerFloorLocation != null
                            && li.productVariantsPerFloorLocation.length > 0
                            && this.inventoryCount.state != InventoryCountStateEnum.Complete)
                            || (li.isOverride
                                && (count.floorLocationId != null && count.floorLocationId != Guid.empty)
                                && this.inventoryCount.state != InventoryCountStateEnum.Complete)
                        ) {
                            let sumData = this.sumFloorLocationActualCount(li.productVariantsPerFloorLocation);
                            li.actualCount = sumData.actualCountSum;
                            li.actualCountUnits = sumData.actualCountUnitsSum;
                        }
                        li.totalActualCountDisplay = this.getTotalActualCount(li);
                        let onHandValue = li.startOnHand == null ? (li.onHand || 0) : li.startOnHand;
                        li.decimalPrecision = (this.isProductUsageEnabled(li) || this.hasPartial(onHandValue)) ? this.decimalPrecision : null;
                    }

                    if (tempCount > 0)
                        this.includeDiscontinued = true;
                    else this.includeDiscontinued = false;

                }

                this.setupProductSearchCriteria();
                this.generateProductLookupCriteria();
                this.takeBackup();
                this.productSearchCriteria.iscounted = null;
                this.makeReadonly();
                this.searchScreen = false;
                if (this.inventoryCount.displayName.substring(0, 8).toUpperCase() == 'CONFLICT')
                    this.isConflict = true;
                else
                    this.isConflict = false;

                this.isNewCount = false;

                this.checkForDisabledUsage();
                
            });
        }

        checkForDisabledUsage() {
            if (this.inventoryCount != null && this.inventoryCount.lineItems.length > 0) {
                var itemsToBeAdjusted = this.inventoryCount.lineItems.filter((item) => item.inventoryCountLineItemModalList.length && !this.isProductUsageEnabled(item));
                if (itemsToBeAdjusted.length > 0) {
                    itemsToBeAdjusted.forEach(item => {
                        item.decimalPrecision = this.decimalPrecision;
                        let partial: number = item.actualCountUnits ? this.roundingService.divideNormalizedNumbers(item.actualCountUnits, item.unitOfMeasureQuantity, item.decimalPrecision) : 0;
                        item.actualCount = item.actualCount + Math.trunc(partial);
                        item.totalActualCountDisplay = this.getTotalActualCount(item);
                        item.inventoryCountLineItemModalList = [];
                    });
                    return this.modalService.alert('MESSAGE_INVENTORY_COUNT_PRODUCT_USAGE_DISABLED', ModalTranslationModes.Translate);
                }
            }
        }

        sumFloorLocationActualCount(productVariantsPerFloorLocation: any): { actualCountSum: number, actualCountUnitsSum?: number } {
            var sum = { actualCountSum: 0, actualCountUnitsSum: null };
            productVariantsPerFloorLocation.forEach(fl=> {
                sum.actualCountSum += fl.perFloorLocationActualCount;
                sum.actualCountUnitsSum += fl.perFloorLocationActualCountUnits;
            });

            return sum;
        }

        searchForInventoryCounts(state: InventoryCountStateEnum): void {
            this.isFilterByComplete = state === InventoryCountStateEnum.Complete ? true : false;

            var data = { "criteria": { "state": state } };
            this.dataService.customMethodData(`${this.baseEndPoint}/List`, "POST", data).then((d) => {
                this.inventoryCounts = d.data;
            });
        }

        /**
         * Get product image link
         * @param {any} product
         * @returns {string} image url
         * */
         getImageURL(product: any): string {
            let imageURL = '';

            if (product && product.meevoFile && product.meevoFile.files.length > 0) {
                let files = product.meevoFile.files;

                for (let i in files) {
                    if (files[i].key === 'Source') {
                        imageURL = files[i].fileUrl;
                    }
                }
            }

            return imageURL;
        }

        // parameter is used for Desktop Version
        updateProductAndUpdateCount(prod?: any, fromBarcode: boolean = false): void {
            // Desktop Version calulate the originalActualCount because this is no longer handled by the function qtyUpdateModal()'s
            // (found in the Inventory Count Controller) modal resolve function
            if (prod != null) {
                this.product = prod;

                if (prod.actualCount != 0)
                    prod.recentlyChanged = 1;
                else
                    prod.recentlyChanged = 0;
            }

            if (this.inventoryCount != null && this.inventoryCount.lineItems != null) {
                for (let i = 0; i < this.inventoryCount.lineItems.length; i++) {
                    if (this.product != null
                        && this.inventoryCount.lineItems[i].variantId == this.product.variantId
                        && this.inventoryCount.lineItems[i].productInventoryType == this.product.productInventoryType) {
                        this.originalActualCount = this.inventoryCount.lineItems[i].actualCount;
                        this.inventoryCount.lineItems[i].isCounted = true;
                    }
                }
            }

            if (this.product != null && this.product.variantId != null) {
                this.product.imageURL = this.getImageURL(prod);

                this.lineItem = this.getLineItem(this.product);

                // if statement and for loop below determine wether or not to add a new product or update an existing one
                let addNewProduct = true;
                if (this.inventoryCount.lineItems != null) {
                    for (let i = 0; i < this.inventoryCount.lineItems.length; i++) {
                        if (this.inventoryCount.lineItems[i].variantId == this.lineItem.variantId
                            && this.inventoryCount.lineItems[i].productInventoryType == this.lineItem.productInventoryType) {
                            if (this.floorLocationId && this.floorLocationId != Guid.empty) {
                                this.inventoryCount.lineItems[i].floorLocationId = this.floorLocationId;
                            }

                            if (!fromBarcode) {
                                this.inventoryCount.lineItems[i].actualCount = this.product.actualCount;
                            }

                            if (prod == null) {
                                this.inventoryCount.lineItems[i].actualCount = this.product.actualCount;
                            }

                            this.inventoryCount.lineItems[i].isDirty = true;
                            addNewProduct = false; //found existing product within the Count details
                            i = 99999;
                            break;
                        }
                    }
                }

                if (addNewProduct) {
                    if (this.inventoryCount.lineItems == null) {
                        this.inventoryCount.lineItems = [];
                    }

                    if (this.inventoryCount.lineItems.length == 0) {
                        this.inventoryCount.productInventoryType = this.product.productInventoryType;
                    }

                    if (!this.inventoryCount.lineItems.some(x => x.variantId == this.lineItem.variantId && x.productInventoryType == this.lineItem.productInventoryType)) {
                        this.lineItem.isDirty = true;
                        this.inventoryCount.lineItems.unshift(this.lineItem);
                    }
                }

                // if the product is null then save to DB because this is the behavior for the mobile version auto save mode
                if (prod == null) {
                    this.updateCountDetail(this.lineItem);
                }
            }
        }

        getLineItem(product) : LineItems {
            return this.prepareLineItemForSaving({
                actualCount: product.actualCount,
                actualCountUnits: product.actualCountUnits,
                id: this.inventoryCount.id,
                variantId: product.variantId,
                manufacturer: product.manufacturer,
                category: product.category,
                subCategory: product.subCategory,
                supplyCategoryEnum: product.supplyCategoryEnum,
                productName: product.productName,
                displayName: product.displayName,
                product_TId: product.product_TId,
                productInventoryType: product.productInventoryType,
                wholeSale: product.wholeSale,
                endOnHand: product.onHand,
                startOnHand: product.onHand,
                isCounted: product.isCounted,
                imageURL: product.imageURL,
                objectState: 2026,
                barCode: product.barCode,
                sku: product.sku,
                onHand: product.onHand,
                onHandDateTime: product.onHandDateTime,
                floorLocationId: this.inventoryCount.floorLocationId,
                productVariantsPerFloorLocation: angular.copy(product.productVariantsPerFloorLocation),
                isDeleted: product.isDeleted,
                isAutosave: this.isAutoSaveEnabled,
                entityVersion: product.entityVersion,
                isDirty: product.isDirty,
                inventoryCountLineItemModalList: angular.copy(product.inventoryCountLineItemModalList),
                totalActualCountDisplay: product.totalActualCountDisplay,
                enableProductUsageTracking: product.enableProductUsageTracking,
                productUsageType: product.productUsageType,
            });
        }

        filterVariantbyFloorLocation(): void {            
            if (this.floorLocationId != null && this.floorLocationId != Guid.empty) {
                if (this.inventoryCount != null && (this.inventoryCount.id != null && this.inventoryCount.id != Guid.empty) && (this.inventoryCount.lineItems != null && this.inventoryCount.lineItems.length > 0)) {
                    //this.inventoryCount.lineItems = this.inventoryCount.lineItems.filter(li=> li.floorLocationId == this.floorLocationId);
                    this.inventoryCount.lineItems.forEach(li=> {
                        li.productVariantsPerFloorLocation = li.productVariantsPerFloorLocation.filter(fl=> fl.floorLocationId == this.floorLocationId);
                    });
                }
            }

            if (this.inventoryCount.lineItems != null && this.inventoryCount.lineItems.length > 0)
                this.inventoryCount.lineItems.forEach(li=> {
                    li.floorLocationId = this.floorLocationId;
                    if (li.floorLocationId == null || li.floorLocationId == Guid.empty)
                        li.isOverride = true;
                    else {
                        if (li.productVariantsPerFloorLocation.length == 0) {

                            li.productVariantsPerFloorLocation.push({
                                floorLocationId: li.floorLocationId,
                                variant_TId: li.variantId,
                                perFloorLocationActualCount: li.actualCount,
                                perFloorLocationActualCountUnits: li.actualCountUnits
                            });
                        }
                        li.productVariantsPerFloorLocation.forEach(fl=> {
                            fl.perFloorLocationActualCount = li.actualCount;
                            fl.perFloorLocationActualCountUnits = li.actualCountUnits;
                            if (this.inventoryCount.id != null && this.inventoryCount.id != Guid.empty) {
                                if (li.finalCount != undefined) {
                                    li.actualCount = li.finalCount;
                                }
                                if (li.finalCountUnits != undefined) {
                                    li.actualCountUnits = li.finalCountUnits;
                                }
                            }
                        });
                    }
                });
            if (this.inSaveProcess || this.inAutoSaveProcess)
                return;
            this.inSaveProcess = true;
            this.busyService.start();
            this.dataService.customMethodData(`${this.baseEndPoint}`, "POST", this.inventoryCount).then((d) => {
                this.dataService.customMethodData(`${this.baseEndPoint}/${d.data.id}`, "GET", null).then((respo) => {
                    this.inventoryCount = respo.data;
                });
            }).catch((error) => {

            }).finally(() => {
                this.busyService.stop();
                this.inSaveProcess = false;
                this.isDirty = false;
            });
        }

        isMobile(): boolean {
			if (window.innerWidth <= 600) {
				return true;
			} else {
				return false;
			}
		}

        disableSpinners() : boolean {
            return this.isFilterByComplete || [InventoryCountStateEnum.Complete, InventoryCountStateEnum.Deleted].indexOf(this.inventoryCount.state) > -1;
        }

        updateCountDetail(lineItems: any): void {
            lineItems.isAutoSaveEnabled = this.isAutoSaveEnabled;

            if (this.inSaveProcess || this.inAutoSaveProcess)
                return;
            this.inSaveProcess = true;
            this.busyService.start();
            this.dataService.customMethodData(`${this.baseEndPoint}/${this.inventoryCount.id}/LineItem`, "POST", lineItems).then((d) => {
                this.selectCount(this.inventoryCount);
            }).catch((error) => {
               
            }).finally(() => {
                this.busyService.stop();
                this.inSaveProcess = false;
                this.isDirty = false;
            });
         
        };

        mergeInventoryCountLineItem(item: any) {
            var ndx = this.inventoryCount.lineItems.findIndex(x => x.variantId == item.variantId && x.productInventoryType == item.productInventoryType);
            if (ndx === -1) {
                this.inventoryCount.lineItems.push(item);
            }
            else {
                this.inventoryCount.lineItems[ndx] = item;
            }
        }

        checkIfCounted(item: any) {
            console.log('checkIfCounted', item)
            if (this.inventoryCount == null) {
                return;
            }

            if (item.isCounted) {
                if (this.inventoryCount.lineItems != null) {
                    item.isDeleted = false;
                }
                else if (this.inventoryCount.lineItems == null) {
                    this.inventoryCount.lineItems = [];
                }
                this.mergeInventoryCountLineItem(item);
            } 
        }

        prepareInventoryCountForSaving() : void {
            this.inventoryCount.manufacturerIds = this.manufacturerMoverModel.isAllSelected ? [] : this.manufacturerMoverModel.collection;
            this.inventoryCount.distributorIds = this.distributorMoverModel.isAllSelected ? [] : this.distributorMoverModel.collection;
            this.inventoryCount.productCatIds = this.productCategoryMoverModel.isAllSelected ? [] : this.productCategoryMoverModel.collection;

            this.inventoryCount.productInventoryType = this.productSearchCriteria.productInventoryType;
            this.inventoryCount.floorLocationId = this.productSearchCriteria.floorLocationId;
            if ((this.inventoryCount.id == null || this.inventoryCount.id == Guid.empty)
                && this.productSearchCriteria.id != null
                && this.productSearchCriteria.id != Guid.empty) {
                this.inventoryCount.id = this.productSearchCriteria.id;
            }
        }

        prepareLineItemForSaving(li: Model.InventoryCountLineItems) : Model.InventoryCountLineItems {
            li.startOnHand = li.onHand;
            if (this.productSearchCriteria.floorLocationId == null || this.productSearchCriteria.floorLocationId == Guid.empty) {
                li.isOverride = true;
            }
            else {
                if (li.productVariantsPerFloorLocation.length == 0) {
                    li.productVariantsPerFloorLocation.push({
                        floorLocationId: li.floorLocationId,
                        variant_TId: li.variantId,
                        perFloorLocationActualCount: li.actualCount,
                        perFloorLocationActualCountUnits: li.actualCountUnits
                    });
                }
                li.productVariantsPerFloorLocation.forEach(fl => {
                    fl.perFloorLocationActualCount = li.actualCount;
                    fl.perFloorLocationActualCountUnits = li.actualCountUnits;
                    if (this.inventoryCount.id != null && this.inventoryCount.id != Guid.empty) {
                        if (li.finalCount != undefined) {
                            li.actualCount = li.finalCount;
                        }
                        if (li.finalCountUnits != undefined) {
                            li.actualCountUnits = li.finalCountUnits;
                        }
                    }
                });
            }

            if (!li.floorLocationId) {
                Object.keys(this.holdLineItems).forEach(key => {
                    if (key > '0') {
                        var index = this.holdLineItems[key].findIndex((x : LineItems) => x.variantId == li.variantId && x.productInventoryType == li.productInventoryType && x.isCounted);
                        if (index >= 0) { 
                            var item = this.holdLineItems[key][index];
                            item.isDeleted = true;
                            item.isCounted = false;
                            item.actualCount = 0;
                            this.dataService.customMethodData(`${this.baseEndPoint}/${this.inventoryCount.id}/LineItem`, "POST", item).then((data) => {
                                this.holdLineItems[key][index] = item;
                            });
                        }
                    }
                })
            }
            return li;
        }

        //add new
        saveInventoryCount(keepEdittable: boolean = false, fromMobile: boolean = false): void {
            if (this.inSaveProcess) {
                return;
            }

            // (BEGIN) Check if auto-save has multiple items lined up
            var timers: ng.IPromise<ng.IPromise<any>>[] = [];
            if (this.autoSaveTimers) {
                for (var key in this.autoSaveTimers) {
                    if (this.autoSaveTimers[key].timer) {
                        timers.push(this.autoSaveTimers[key].timer);
                    }
                }
            }
            // if there are auto-saves lined up, wait for those to finish before performing another save
            if (timers.length > 0) {
                this.busyService.start();
                this.$q.all(timers).then((morePromises) => {
                    this.$q.all(morePromises).then(() => {
                        this.saveInventoryCount(keepEdittable);
                    });
                });
                return;
            }
            // (END) Check if auto-save has multiple items lined up

            this.inSaveProcess = true;
            if (this.scannerOpened !== 'mobile') {
                this.closeBarcodeScanner();
            }

            this.prepareInventoryCountForSaving();

            if (this.prepareInventoryCountLineItemsForSaving()) {
                this.busyService.stop();
                this.modalService.alert('MESSAGE_INVENTORY_COUNT_FIX_ON_HAND_CONFLICTS_UPON_SAVE', Meevo.Components.Modal.ModalTranslationModes.Translate, true)
                    .then(() => {
                        this.saveInventoryCountWorker(keepEdittable);
                        this.closeCustomModal();
                        if (fromMobile) {
                            this.searchForInventoryCounts(this.openInventoryCountStateEnum);
                            this.controller.viewSwitch('editCount');
                        }
                    });
            }
            else {
                this.saveInventoryCountWorker(keepEdittable);
                this.closeCustomModal();
                if (fromMobile) {
                    this.searchForInventoryCounts(this.openInventoryCountStateEnum);
                    this.controller.viewSwitch('editCount');
                }
            }
        }

        saveInventoryCountWorker(keepEditable = false): ng.IPromise<any> {
            this.busyService.start();
            this.clearAllAutoSaveTimers();

            return this.dataService.customMethodData(`${this.baseEndPoint}`, "POST", this.inventoryCount).then((d) => {
                this.inventoryCount = d.data;
                this.productSearchCriteria.id = this.inventoryCount.id;

                if (this.inventoryCount != null && this.inventoryCount.lineItems && this.inventoryCount.lineItems.length > 0) {
                    this.inventoryCount.lineItems.forEach(li => {
                        if (!li.isOverride
                            && li.productVariantsPerFloorLocation != null
                            && li.productVariantsPerFloorLocation.length > 0) {
                            let sumData = (this.productSearchCriteria.floorLocationId && this.productSearchCriteria.floorLocationId != Guid.empty)
                                ? this.sumFloorLocationActualCount(li.productVariantsPerFloorLocation.filter(fl => fl.floorLocationId == this.productSearchCriteria.floorLocationId))
                                : this.sumFloorLocationActualCount(li.productVariantsPerFloorLocation);
                            li.actualCount = sumData.actualCountSum;
                            li.actualCountUnits = sumData.actualCountUnitsSum;
                            li.floorLocationId = this.productSearchCriteria.floorLocationId;
                        }
                        li.totalActualCountDisplay  = this.getTotalActualCount(li);
                        let onHandValue = li.startOnHand == null ? (li.onHand || 0) : li.startOnHand;
                        li.decimalPrecision = (this.isProductUsageEnabled(li) || this.hasPartial(onHandValue)) ? this.decimalPrecision : null;
                    });
                }
                if (this.inventoryCount.displayName.substring(0, 8).toUpperCase() == 'CONFLICT')
                    this.isConflict = true;
                else
                    this.isConflict = false;

                this.takeBackup();
                // this.searchForInventoryCounts(InventoryCountStateEnum.Open);
                if (!keepEditable) {
                    this.makeReadonly();
                }

            }).catch((error) => {
                console.log('error saving inventory count', error);
                this.cancel();
                this.selectCount(this.inventoryCount);
            }).finally(() => {
                this.busyService.stop();
                this.inSaveProcess = false;
                this.isDirty = false;
            });
        }

        prepareInventoryCountLineItemsForSaving(saveAllItems: boolean = false): boolean {
            let hasOnHandConflict: boolean = false;
            if (this.inventoryCount.lineItems != null && this.inventoryCount.lineItems.length > 0) {
                this.inventoryCount.lineItems = this.inventoryCount.lineItems.filter(item => saveAllItems || item.isDirty || (item.startOnHand != null && item.onHand != item.startOnHand));
                this.inventoryCount.lineItems.forEach(li => {
                    li.isDirty = true;
                    hasOnHandConflict = hasOnHandConflict || (li.startOnHand != null && li.onHand != li.startOnHand);
                    li = this.prepareLineItemForSaving(li);
                });
            }
            return hasOnHandConflict;
        }

        isMiscSupplyCount() : boolean {
            return (this.productSearchCriteria && this.productSearchCriteria.productInventoryType == ProductInventoryTypeEnum.Other)
                || (this.inventoryCount && this.inventoryCount.productInventoryType == ProductInventoryTypeEnum.Other);
        }

        getSupplyCatgeoryDesc(supplyTypeEnum: Meevo.Model.SupplyCategoryEnum) : string {
            return this.$translate.instant(Meevo.Model.SUPPLY_CATEGORY_DESCRIPTION[supplyTypeEnum]) || Meevo.Model.SupplyCategoryEnum[supplyTypeEnum];
        }

        mobileRemoveLineItem(selectedLineItem: any) : void {
            if (!this.isStateOpen()) return;
            var swiperInstance = $("#swiper-" + selectedLineItem.entityVersion)[0]["swiper"] || null;
            console.log('remove line item', selectedLineItem, swiperInstance.activeIndex, swiperInstance.activeTabIndex);
            if (!swiperInstance || swiperInstance.activeIndex < 1) return;
            this.removeLineItem(selectedLineItem, swiperInstance);            
        }

        allowSlider(e) : void {
            console.log('allowslier', e)
            if (!this.isStateOpen()) {
                e.stopPropagation();    
            }
        }

        removeLineItem(selectedLineItem: any, swiperInstance: any = null): void {
           
            this.modalService.warning("MESSAGE_DELETE_CONFIRMATION", 0, false, {
                showCancelButton: true,
                okButtonContentKey: 'LABEL_YES',
                cancelButtonContentKey: 'LABEL_NO',
                cancelButtonHotKey: 'MODAL_NO_BUTTON',
                okButtonHotKey: 'MODAL_YES_BUTTON'
            }).then(() => {
                if (swiperInstance) {
                    swiperInstance.slideTo(0);
                }
                if (this.inventoryCount.lineItems != null) {
                    this.inventoryCount.lineItems.forEach(x => {
                        if (x.variantId == selectedLineItem.variantId
                            && x.productInventoryType == selectedLineItem.productInventoryType) {
                            x.isDeleted = true;
                            x.isCounted = false;
                            x.isDirty = true;
                            this.product = x;
                        }
                    });
                    this.handleAutoSave(this.product, true);
                    this.highlightId = null;
                }
            }).catch((e) => {
                if (swiperInstance) {
                    swiperInstance.slideTo(0);
                }
            });
            
        }

        commitCount(): ng.IPromise<any> {
            var scope = this;

            this.confirmationMessage = "Count Saved!";
            if (this.inventoryCount.lineItems != null && this.inventoryCount.lineItems.length > 0) {
                return this.modalService.warning("MESSAGE_INVENTORY_COUNT_CONFIRM_COMMIT", ModalTranslationModes.Translate, false, { showCancelButton: true, cancelButtonContentKey: 'LABEL_NO', cancelButtonHotKey: 'MODAL_NO_BUTTON', okButtonHotKey: 'MODAL_YES_BUTTON', okButtonContentKey: 'LABEL_YES' })
                    .then((data) => {
                        var forceCommit = (this.inventoryCount != null && this.inventoryCount.displayName.substring(0, 8).toUpperCase() == 'CONFLICT');
                        if (this.inventoryCount != null && this.inventoryCount.id != null && this.inventoryCount.id != Guid.empty) {
                            if (this.inventoryCount.lineItems != null && this.inventoryCount.lineItems.length > 0) {
                                this.inventoryCount.lineItems.forEach(variant => {
                                    if (!variant.isOverride && variant.productVariantsPerFloorLocation != null && variant.productVariantsPerFloorLocation.length > 0) {
                                        let sumData = this.sumFloorLocationActualCount(variant.productVariantsPerFloorLocation);
                                        variant.actualCount = sumData.actualCountSum;
                                        variant.actualCountUnits = sumData.actualCountUnitsSum;
                                    }
                                });
                            }
                        }

                        if (this.inSaveProcess || this.inAutoSaveProcess)
                            return;
                        this.inSaveProcess = true;
                        this.busyService.start();

                        return this.dataService.customMethodData(`${this.baseEndPoint}/Commit`, "PUT", { forceCommit: forceCommit, ...this.inventoryCount})
                            .then((response): ng.IPromise<any> => {
                                if (!response.data) {
                                    this.busyService.stop();
                                    return this.modalService.alert("MESSAGE_INVENTORY_COUNT_NO_RESPONSE_ERROR");
                                }
                                else if (response.data.errorMessage) {
                                    this.busyService.stop();
                                    return this.modalService.alert(response.data.errorMessage);
                                }
                                else if (response.data.isAllInConflict) {
                                    this.selectCount(response.data.inventoryCount);
                                    this.busyService.stop();
                                    var msg = this.$translate.instant("MESSAGE_INVENTORY_COUNT_ALL_IN_CONFLICT", { newDisplayName: response.data.inventoryCount.displayName })
                                    return this.modalService.alert(msg);
                                }
                                else if (response.data.conflictId != null && response.data.conflictId != Guid.empty) {
                                    var count: Meevo.Model.InventoryCount;
                                    count = {
                                        id: response.data.conflictId,
                                        displayName: "",
                                        dateCreated: null,
                                        dateUpdated: null,
                                        entityVersion: 0,
                                        productInventoryType: null,
                                        lineItems: null,
                                        state: null,
                                        userName: "",
                                        iscounted: null,
                                        inventoryCountOnly: false,
                                        orderItemsBy: this.inventoryCount.orderItemsBy,
                                        distributorIds: [],
                                        manufacturerIds: [],
                                        productCatIds: []
                                    };
                                    this.selectCount(count);
                                    this.busyService.stop();
                                    return this.modalService
                                        .alert("MESSAGE_INVENTORY_COUNT_COMMITTED_WITH_CONFLICT", ModalTranslationModes.Translate)
                                        .then(() => {
                                            this.makeReadonly();
                                            this.controller.viewSwitch('actionConfirmation');
                                            this.searchForInventoryCounts(InventoryCountStateEnum.Open);
                                            this.$timeout(() => { $("#inventoryCountSearch").click(); }, 1);
                                        });
                                }
                                else {
                                    this.inventoryCount = response.data.inventoryCount;
                                    // calculate the totalActualCountDisplay
                                    if (this.inventoryCount != null && this.inventoryCount.lineItems && this.inventoryCount.lineItems.length > 0) {
                                        this.inventoryCount.lineItems.forEach(li => {
                                            li.totalActualCountDisplay = this.getTotalActualCount(li);
                                            let onHandValue = li.startOnHand == null ? (li.onHand || 0) : li.startOnHand;
                                            li.decimalPrecision = (this.isProductUsageEnabled(li) || this.hasPartial(onHandValue)) ? this.decimalPrecision : null;
                                        });
                                    }
                                    this.makeReadonly();
                                    this.controller.viewSwitch('actionConfirmation');
                                    this.searchForInventoryCounts(InventoryCountStateEnum.Open);
                                    this.$timeout(() => { $("#inventoryCountSearch").click(); }, 1);
                                }
                            }).catch((error) => {

                            }).finally(() => {
                                this.busyService.stop();
                                this.inSaveProcess = false;
                                this.isDirty = false;
                            });
                    });
            }
        }

        makeReadonly() : void {
            this.mode = MaintenanceFormState.Readonly;
        }
        
        mobileSave() : void {
            this.makeReadonly();
            this.addExpanded = false;
            this.closeBarcodeScanner();
            this.controller.viewSwitch('action');
        }

        isInventoryCountDetailEmpty(): boolean {
            if (this.inventoryCount != null &&
                this.inventoryCount.lineItems != null &&
                this.inventoryCount.lineItems.filter(x => x.isCounted).length > 0)
                return false;
            else
                return true;
        }

        deleteCount(): void {
            this.prepareInventoryCountLineItemsForSaving(true);
            var scope = this;            
            scope.confirmationMessage = "Count Deleted!";
            this.modalService.warning("Are you sure you want to delete this count?", 0, false, {
                showCancelButton: true, cancelButtonContentKey: 'LABEL_NO', cancelButtonHotKey: 'MODAL_NO_BUTTON',
                okButtonHotKey: 'MODAL_YES_BUTTON', okButtonContentKey: 'LABEL_YES'
            }).then((data) => {
                this.inventoryCount.state = InventoryCountStateEnum.Deleted;
                if (this.inSaveProcess || this.inAutoSaveProcess)
                    return;
                this.inSaveProcess = true;
                this.busyService.start();
                this.dataService.customMethodData(`${this.baseEndPoint}`, "PUT", this.inventoryCount).then((d) => {
                    scope.controller.viewSwitch('actionConfirmation');
                    this.searchForInventoryCounts(InventoryCountStateEnum.Open); // Mobile Version Search
                    // this.mode = MaintenanceFormState.Readonly;
                    this.searchScreen = true;
                    this.$timeout(() => {
                        $("#inventoryCountSearch").click(); // Desktop Version Search
                    }, 1);
                }).catch((error) => {

                }).finally(() => {
                    this.busyService.stop();
                    this.inSaveProcess = false;
                    this.isDirty = false;
                });
            });
        }

        sumTotalItems(): number {
            let sum = 0;
            if (this.products != null) {
                for (let i = 0; i < this.products.length; i++) {
                    sum += this.products[i].actualCount;
                }
            }
            return sum;
        }

        setProduct(prod: any) {
            if (prod.startOnHand == null || prod.onHand == null) {
                if (prod.productVariant) {
                    this.product = prod.productVariant;
                } else {
                    this.product = prod;
                }
            } else {
                this.product = prod;
            }
        }

        returnTextEnumValue(productInventoryType: ProductInventoryTypeEnum): string {
            if (productInventoryType == ProductInventoryTypeEnum.Retail)
                return "Retail";
            else if (productInventoryType == ProductInventoryTypeEnum.ShopSupply)
                return "Wholesale";
            else {
                return "Retail Or Wholesale";
            }
        }

        isNullOrEmpty(object: any): boolean {
            return Boolean(object);
        }

        returnConcatinatedName(item: any): string {
            if (item.displayName != null && item.displayName.length != null && item.displayName.length > 0) {
                let concatdisplayName = "";
                for (let i = 0; i < item.displayName.length; i++) {
                    if (i + 1 < item.displayName.length)
                        concatdisplayName += item.displayName[i] + " / ";
                    else {
                        concatdisplayName += item.displayName[i];
                    }
                }
                return concatdisplayName;
            }
            return "";
        }

        returnAttributeConcatinatedName(attributes: any): string {
            if (attributes != null && attributes.length != null && attributes.length > 0) {
                let concatdisplayName = "";
                for (let i = 0; i < attributes.length; i++) {
                    for (let j = 0; j < attributes[i].displayName.length; j++) {
                        if (j + 1 < attributes[i].displayName.length || i + 1 < attributes.length)
                            concatdisplayName += attributes[i].displayName[j] + " / ";
                        else {
                            concatdisplayName += attributes[i].displayName[j];
                        }
                    }
                }
                return concatdisplayName;
            }
            return "";
        }

        validateBarCode(filter, floorLocation): void {
            if (filter && floorLocation) {
                let criteria = {
                    criteria: {
                        productObjectState: Meevo.Model.ObjectStateEnum.Active,
                        productInventoryType: this.inventoryCount.productInventoryType,
                        variantObjectState: [Meevo.Model.ObjectStateEnum.Active, Meevo.Model.ObjectStateEnum.Inactive],
                        isInventoryTrackable: true,
                        floorLocationId: floorLocation,
                        filter: filter,
                        id: this.inventoryCount.id,
                        inventoryCountOnly: this.inventoryCount.inventoryCountOnly,
                        iscounted: this.inventoryCount.iscounted
                    }
                };

                if (!this.includeDiscontinued) {
                    criteria.criteria.variantObjectState = [Meevo.Model.ObjectStateEnum.Active];
                }

                this.dataService.customMethodData(`${this.baseEndPoint}/ProductVariant/ValidateBarCode`, "POST", criteria);
            }
        }

        changeFilter(): void {
            this.recentlyChangedNumber += 1;
            this.recentlyChangedVariableAttribute = "recentlyChanged" + this.recentlyChangedNumber;
        }
        absoluteValue(val): number {
            return Math.abs(val);
        }

        showItemForRecentChanges(item): boolean {
            if (item[this.recentlyChangedVariableAttribute] == 1)
                return true;
            else
                return false;
        }

        setRecentlyChanged(item): void {
            if (item != null) {
                item.isDirty = true;
                item[this.recentlyChangedVariableAttribute] = (item.isCounted) ? 1 : 0;
            }
            this.isDirty = true;
        }

        getProductTotals(whichOne: string): number {
            if (!this.inventoryCount || !this.inventoryCount.lineItems || this.inventoryCount.lineItems.filter(item => item && item.isCounted && !item.isDeleted).length === 0) return 0;
            var returnVal = 0;
            switch (whichOne) {
                case 'items':
                    returnVal = this.inventoryCount.lineItems
                        .filter(item => item.isCounted && !item.isDeleted)
                        .map(item => item.actualCount)
                        .reduce((prev, next) => prev + next);
                    break;
                case 'products':
                    returnVal = this.inventoryCount.lineItems
                        .filter(item => item.isCounted && !item.isDeleted)
                        .length;
                    break;
            }
            return returnVal;
        }

        onCountChanged(item): void {
            if (!this.isStateOpen()) return;

            if (!this.isEditing()) {
                this.mode = MaintenanceFormState.Editing;
            }

            if (!item) {
                return;
            }

            if (item.actualCount > 0) {
                this.product = item;
                item.isCounted = true;
            }

            item.totalActualCountDisplay = this.getTotalActualCount(item);

            this.checkIfCounted(item);
            this.setRecentlyChanged(item);

            item.gainLoss = this.gainLossValue(item);

            this.handleAutoSave(item);
        }        

        handleAutoSave(item, checkboxClicked = false) {
            if (!this.isAutoSaveEnabled || !this.isStateOpen()) return;
            if (!this.inventoryCount.id) {
                // Save new Inventory Count since there's no ID yet
                if (this.inSaveProcess || this.inAutoSaveProcess) {
                    //if we are still in the process of fetching initial inventory count id sleep before processing more autosaves to prevent unwanted empty counts created
                    this.$timeout(() => {
                        this.handleAutoSave(item, checkboxClicked);
                    }, 1000)
                    return;
                }
                this.prepareInventoryCountForSaving();
                var dataToPost = angular.copy(this.inventoryCount);
                dataToPost.lineItems = [];
                this.inSaveProcess = true;
                this.dataService.customMethodData(`${this.baseEndPoint}`, "POST", dataToPost).then((d) => {
                    if (!d || !d.data) return;
                    this.inSaveProcess = false;
                    var holdLineItems = this.inventoryCount.lineItems;
                    this.inventoryCount = d.data;
                    this.inventoryCount.floorLocationId = item.floorLocationId;
                    this.inventoryCount.lineItems = holdLineItems;
                    this.productSearchCriteria.id = this.inventoryCount.id;
                    this.setAutoSaveInfo(item, checkboxClicked);
                });
            }
            else {
                this.setAutoSaveInfo(item, checkboxClicked);
            }
            
        }

        clearAllAutoSaveTimers() {
            for (var item in this.autoSaveTimers) {
                if (this.autoSaveTimers[item].timer) {
                    this.$timeout.cancel(this.autoSaveTimers[item].timer);
                }
            };
        }

        private generateAutoSaveKey(item: LineItems) {
            return item[autoSaveKeyPrimary] + item[autoSaveKeySecondary];
        }

        setAutoSaveInfo(item, checkboxClicked) {
            if (!this.isAutoSaveEnabled) return;
            var key = this.generateAutoSaveKey(item);
            if (!this.autoSaveTimers[key]) {
                this.autoSaveTimers[key] = {};
            }

            // only process if different or checkbox or delete icon used
            if (item.actualCount === item.finalCount && item.actualCountUnits === item.finalCountUnits && !checkboxClicked) {
                if (this.autoSaveTimers[key].timer) {
                    this.$timeout.cancel(this.autoSaveTimers[key].timer);
                    delete this.autoSaveTimers[key];
                }
                return;
            }
            else {
                this.autoSaveTimers[key].lineItem = this.getLineItem(item);
                this.autoSaveTimers[key].product = this.product;
            }
            
            if (this.autoSaveTimers[key].timer) {
                // item changed again, cancel old timer
                this.$timeout.cancel(this.autoSaveTimers[key].timer);
            } 
            
            this.autoSaveTimers[key].timer = this.$timeout(() => { 
                this.inAutoSaveProcess = true;
                var promise = this.dataService.customMethodData(`${this.baseEndPoint}/${this.inventoryCount.id}/LineItem`, "POST", this.getLineItem(this.autoSaveTimers[key].product)).then((d) => {
                    this.showAutoSaveSuccessful = true;
                    this.inventoryCount.lineItems.forEach(x => {
                        if (this.generateAutoSaveKey(x) === key) {
                            // update so we can detect changes to this moving forward
                            x.finalCount = x.actualCount;
                            x.finalCountUnits = x.actualCountUnits;
                            x.isDirty = false;
                            if (x.onHand != x.startOnHand) {
                                x.startOnHand = x.onHand;
                            }
                        }
                    });
                    this.$timeout(() => {
                        this.showAutoSaveSuccessful = false;
                    }, 1500);
                }).catch((e) => {
                    console.error('auto saved failed count: ' + this.inventoryCount.id, e);
                    this.cancel();
                    return this.selectCount(this.inventoryCount);
                }).finally(() => {
                    this.inAutoSaveProcess = false;
                    this.isDirty = false;
                });
                delete this.autoSaveTimers[key];
                return promise;
            }, autoSaveDelay);
        }

        checkCountedFilter(item): boolean {
            return (typeof this.inventoryCount.iscounted === 'boolean') ? item.isCounted === this.inventoryCount.iscounted : true;
        }

        setStartOnHand() {
            this.inventoryCount.lineItems.map(x => x.startOnHand = x.onHand);
        }

        totalOnhand(): number {
            var sum = 0;
            let decimalPrecision: number = null;
            if (this.inventoryCount != null && this.inventoryCount.lineItems != null) {
                this.inventoryCount.lineItems.filter(x => x.isCounted).forEach((lI: LineItems) => {
                    decimalPrecision = decimalPrecision || lI.decimalPrecision;
                    let onHandValue = lI.startOnHand == null ? (lI.onHand || 0) : lI.startOnHand;
                    sum = this.roundingService.add(sum, onHandValue, decimalPrecision);
                });
            }
            this.inventoryCount.decimalPrecision = decimalPrecision;
            var onHandRule = this.$filter('inventoryOnHandRule') as any;
            return onHandRule(sum);
        }
        totalCount(): number {
            var sum = 0;
            let decimalPrecision: number = null;
            if (this.inventoryCount != null && this.inventoryCount.lineItems != null) {
                this.inventoryCount.lineItems.filter(x => x.isCounted).forEach((lI: LineItems) => {
                    decimalPrecision = decimalPrecision || lI.decimalPrecision;
                    sum = this.roundingService.add(sum, (lI.totalActualCountDisplay || 0), decimalPrecision);
                });
            }
            this.inventoryCount.decimalPrecision = decimalPrecision;
            return sum;
        }
        totalGainLoss(): number {
            var sum = 0;
            if (this.inventoryCount != null && this.inventoryCount.lineItems != null) {
                this.inventoryCount.lineItems.filter(x => x.isCounted).forEach(lI => {
                    sum = this.roundingService.add(sum, this.gainLossValue(lI));
                });
            }
            return sum;
        }

        totalUnitsDisplay(isOnHand?: boolean): number {
            var sum = 0;
            if (this.inventoryCount != null && this.inventoryCount.lineItems != null) {
                this.inventoryCount.lineItems.filter(x => x.isCounted).forEach((lI: LineItems) => {

                    if (isOnHand) {
                        let onHandValue = lI.startOnHand == null ? (lI.onHand || 0) : lI.startOnHand;
                        var unit = this.roundingService.multiply(onHandValue, lI.unitOfMeasureQuantity)
                    } else {
                        var unit = this.roundingService.multiply(lI.totalActualCountDisplay, lI.unitOfMeasureQuantity)
                    }
                    sum = this.roundingService.add(sum, (unit || 0));
                });
            }
            return sum;
        }

        onSearch(index: number, products: any, context: any): void {
            context.inventoryCount.orderItemsBy = context.inventoryCountOrder = context.inventoryCountSortOption.fieldName;
        }

        slideClick() : void {
            if (this.isStateOpen()) {
                this.edit();
            }
        }
        
        toggleCount(item) {
            this.checkIfCounted(item);
            this.setRecentlyChanged(item);
            item.isDirty = this.isDirty = true;
            this.product = item;
            if (this.isAutoSaveEnabled) {
                this.handleAutoSave(item, true);
            }
        }

        showMessageToSaveFirst() {
            this.modalService.warning("MESSAGE_INV_COUNT_NEED_TO_SAVE_LIST", Components.Modal.ModalTranslationModes.Translate);
        }

        showSidebar = () => {

            setTimeout(() => {
                this.$mdSidenav('inventoryCountSidenav').open();
            }, 0);

        }
        hideSidebar = () => {
            this.$mdSidenav('inventoryCountSidenav').close();
        }

        showNotCountedSinceUpdated() {
            if (!this.productSearchCriteria.chkShowNotCountedSince) {
                this.productSearchCriteria.showProdNotCntSince = null;
            }
        }

        gainLossValue(item: LineItems) {
            var onHand: number = (item.startOnHand == 0) ? 0 : (item.startOnHand || item.onHand);
            var totalActualValue: number = this.getTotalActualCount(item);
            totalActualValue = (item.startOnHand === null) ? (totalActualValue || onHand) : totalActualValue;
            return this.roundingService.subtract(this.roundingService.multiply(item.wholeSale, totalActualValue), this.roundingService.multiply(item.wholeSale, onHand)) || 0;
        }

        gainLossDisplayValue(item) {
            if (!item) return '';
            if (!item.isCounted) {
                return 0;
            }
            if (item.gainLoss == null) {
                item.gainLoss = this.gainLossValue(item);
            }
            var gainLossStr = this.meevoCurrency(Math.abs(item.gainLoss || 0));
            return (item.gainLoss < 0) ? "(" + gainLossStr + ")" : gainLossStr;
        }

        isInConflict(item) {
            if (!item) return false;
            var startOnHand: number = (item.startOnHand == 0) ? 0 : (item.startOnHand || item.onHand);
            return (this.inventoryCount.id && startOnHand != item.onHand && !this.isHideOnHand && this.inventoryCount.state != 1688);
        }

        swipeLeft(prod) : void {
            console.log('swiped left', prod);
            prod.showTrash = true;
        }
        swipeRight(prod) : void {
            console.log('swiped right', prod);
            prod.showTrash = false;
        }

        startMobileCount() : void {
            this.edit();
            this.isAutoSaveEnabled = true;
            if (this.inSaveProcess) {
                this.$timeout(() => {
                    this.search();
                }, 1000)
                return;
            } else {
                this.search();
            }
        }

        startNewCount() : void {
            this.resetInventoryCount();
            this.setInventoryCountDefaults();
            this.createNewCount();            
        }

        isShopSupply(variant) : boolean {
            if (!variant) return false;
            return variant.productInventoryType == Meevo.Model.ProductInventoryTypeEnum.ShopSupply;
        }

        toggleAddExpanded() : void {
            this.addExpanded = !this.addExpanded;
            if (this.addExpanded) {
                $('#product-lookup-input input').bind('blur', () => {
                    setTimeout(() => {
                        this.controller.$scope.$apply();
                    }, 1);
                })
            }                
            setTimeout(() => {
                this.controller.$scope.$apply();
            }, 1);
            
        }

        productSelected() : void {
            this.controller.viewSwitch('count');
            if (this.productLookup) {
                this.productLookup.isCounted = true;
                this.productLookup.isDirty = true;
                this.productLookup.actualCount = 0;
                this.productLookup.actualCountUnits = null;
                this.productLookup.totalActualCountDisplay = 0;
                let onHandValue = this.productLookup.startOnHand == null ? (this.productLookup.onHand || 0) : this.productLookup.startOnHand;
                this.productLookup.decimalPrecision = (this.isProductUsageEnabled(this.productLookup) || this.hasPartial(onHandValue)) ? this.decimalPrecision : null;

                this.productVariantFilter = "";
                if (!this.inventoryCount.lineItems.some(x => x.variantId == this.productLookup.variantId && x.productInventoryType == this.productLookup.productInventoryType)) {
                    this.inventoryCount.lineItems.unshift(this.productLookup);
                    this.inventoryCount.decimalPrecision = this.inventoryCount.decimalPrecision || this.productLookup.decimalPrecision;
                }
                this.highlightAddedItem(this.productLookup);
                this.product = this.productLookup;
                this.handleAutoSave(this.productLookup, true);
            }
        }
        
        productFilterChange() : void {
            if (!this.productVariantFilter) {
                this.searchExpanded = false;
            }
        }

        showMobileCameraIcon() : boolean {
            return this.isStateOpen() && !this.isReadonly()
        }

        showMobileSaveIcon() : boolean {
            return this.isStateOpen() && this.controller.mobileView !== 'action';
        }

        availableToSave() : boolean {
            return !!(this.inventoryCount.id) || !this.isInventoryCountDetailEmpty()
        }

        mobileBackButtonClicked() : void {
            if (this.controller.mobileView == 'action') {
                this.controller.viewSwitch('count');
                this.edit();
            } else {
                this.back();
            }
        }

        closeBarcodeScanner() : void {
            this.scannerOpened = null;
        }

        getMobileVirtualRepeatHeight() : string {
            let scrollTop     = $(window).scrollTop();
            let elementOffset = $('.count-detail-wrapper').offset().top
            let distance      = (elementOffset - scrollTop);
            let vh = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0);
            let footerHeight = $('#mobile-inventorycount-footer').height();
            return `${vh - (distance + footerHeight)}px`
        }

        attachMobileProductLookupHandler() {
            // otherwise dynamic height of mobile virtual repeater doesn't change until user interaction
            $('#mobile-count #product-lookup-input input').on('blur', () => {
                setTimeout(() => {
                    this.controller.$scope.$apply();    
                }, 1000);
            })
        }

        setPartialUsage(event, entry: LineItems) {
            event.stopPropagation();

            let modalOptions: Meevo.Components.Controls.PartialUsageModalOptions = {
                productId: entry.id,
                variantIdInitiator: entry.variantId,
                parentType: Meevo.Plugins.Product.ProductInfoModalParent.InventoryCount,
                entry: entry,
                quantityWholeList: entry.inventoryCountLineItemModalList
                    && entry.inventoryCountLineItemModalList.length > 0
                    && entry.inventoryCountLineItemModalList.some(item => item.productUsageType == ProductUsageAmountTypeEnum.WholeProduct)
                    ? entry.inventoryCountLineItemModalList
                        .filter(item => item.productUsageType == ProductUsageAmountTypeEnum.WholeProduct)
                        .map((item, ndx, arr) => <Meevo.Model.QuantityValueType>{ quantity: item.quantity })
                    : [{ quantity: entry.actualCount || 0 }],
                quantityUnitsList: entry.inventoryCountLineItemModalList
                    && entry.inventoryCountLineItemModalList.length > 0
                    && entry.inventoryCountLineItemModalList.some(item => item.productUsageType == ProductUsageAmountTypeEnum.PartialAmount)
                    ? entry.inventoryCountLineItemModalList
                        .filter(item => item.productUsageType == ProductUsageAmountTypeEnum.PartialAmount)
                        .map((item, ndx, arr) => <Meevo.Model.QuantityValueType>{ quantity: item.quantity })
                    : [{ quantity: entry.actualCountUnits || 0 }],
                totalCompositeValue: null,
            }

            let options: Meevo.Components.Modal.IModalOptions = {
                templateUrl: "app/components/controls/productPartialUsage/partialUsage.template.html",
                controller: "meevo.components.controls.productPartialUsage.PartialUsageController",
                controllerAs: "vm",
                bindToController: true,
                locals: {
                    options: modalOptions
                }
            }
            this.modalService.showCustom(options)
                .then((applied) => {
                    if (applied) {
                        entry.isDirty = true;                        
                        entry.totalActualCountDisplay = modalOptions.totalCompositeValue;
                        entry.actualCount = modalOptions.totalWhole;
                        entry.actualCountUnits = modalOptions.totalUnits;
                        entry.floorLocationId = entry.floorLocationId ? entry.floorLocationId: this.inventoryCount.floorLocationId;
                        entry.inventoryCountLineItemModalList = [
                            ...modalOptions.quantityWholeList.map((item, index) => (
                                {
                                    sortOrder: index,
                                    productUsageType: ProductUsageAmountTypeEnum.WholeProduct,
                                    quantity: item.quantity,
                                    productInventoryType: entry.productInventoryType,
                                    floor_LId: entry.floorLocationId ? entry.floorLocationId : null
                                }
                            )),
                            ...modalOptions.quantityUnitsList.map((item, index) => (
                                {
                                    sortOrder: index,
                                    productUsageType: ProductUsageAmountTypeEnum.PartialAmount,
                                    quantity: item.quantity,
                                    productInventoryType: entry.productInventoryType,
                                    floor_LId: entry.floorLocationId ? entry.floorLocationId : null
                                }
                            )),
                        ];                      
                        entry.isCounted = true;  // #79091
                        if (entry.isCounted) {
                            entry.isDeleted = false;
                        }
                        entry.gainLoss = this.gainLossValue(entry);
                        this.product = entry;
                        this.checkIfCounted(entry);
                        this.handleAutoSave(entry);
                    }
                });
        }

        getTotalActualCount(item: LineItems): number {
            if (this.isProductUsageEnabled(item)) {
                let partial: number = item.actualCountUnits ? this.roundingService.divideNormalizedNumbers(item.actualCountUnits, item.unitOfMeasureQuantity, this.decimalPrecision) : 0;
                return this.roundingService.add(item.actualCount || 0, partial, this.decimalPrecision);
            }
            return item.actualCount || 0;
        }

        getUnitsDisplay(item: LineItems, onHandValue?: number): number { 
            if (onHandValue || onHandValue === 0) {
                return this.roundingService.multiply(onHandValue, item.unitOfMeasureQuantity);
            } else {
                let wholeUnits: number = this.roundingService.multiply(item.actualCount, item.unitOfMeasureQuantity);
                return this.roundingService.add(wholeUnits, item.actualCountUnits);
            }
        }

        isProductUsageEnabled(variant: LineItems): boolean {
            return this.tenantEnableProductUsageTracking && variant && variant.enableProductUsageTracking && variant.productUsageType == ProductUsageAmountTypeEnum.PartialAmount;
        }

        getDecimalPrecision(item: any): number {
            return (this.tenantEnableProductUsageTracking && item && item.enableProductUsageTracking && item.productUsageType == ProductUsageAmountTypeEnum.PartialAmount)
                ? this.decimalPrecision
                : null;
        }

        hasPartial(item: number): boolean {
            return !Number.isInteger(item);
        }

        scrollHeader(event) {
            $(".inventory-table.clone")[0].scrollLeft = $(".inventory-table-container.meevo-scrollbar")[0].scrollLeft;
        }
        /**
         * Close current tab
         * */
        closeContext(): void {
            this.$rootScope.$broadcast(Meevo.Components.Common.Messages.CLOSE_CONTEXT, this.$state['current'], null);
        }

    }
}
